// @generated by protobuf-ts 2.11.1 with parameter long_type_string,generate_dependencies,output_legacy_commonjs
// @generated from protobuf file "sennotech/base/organization/organization.proto" (package "base.organization", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { OrganizationContext } from "../access_context";
import { Permission } from "./permission";
import { BoolValue } from "../../google/protobuf/wrappers";
import { ListValue } from "../../google/protobuf/struct";
import { StringValue } from "../../google/protobuf/wrappers";
import { Int64Value } from "../../google/protobuf/wrappers";
/**
 * @generated from protobuf message base.organization.ListOrganizationByAccountIdResponse
 */
export interface ListOrganizationByAccountIdResponse {
    /**
     * @generated from protobuf field: repeated base.organization.Organization organizations = 1
     */
    organizations: Organization[];
}
/**
 * @generated from protobuf message base.organization.ListOrganizationByAccountIdRequest
 */
export interface ListOrganizationByAccountIdRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountId = 1
     */
    accountId?: Int64Value; // 若不传，则从access token中获取
    /**
     * @generated from protobuf field: google.protobuf.StringValue type = 2
     */
    type?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue name = 3
     */
    name?: StringValue;
}
/**
 * @generated from protobuf message base.organization.ListOrganizationsRequest
 */
export interface ListOrganizationsRequest {
    /**
     * @generated from protobuf field: int32 page_num = 1
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: base.organization.ListOrganizationsRequest.OrderBy order_by = 3
     */
    orderBy?: ListOrganizationsRequest_OrderBy; // 默认按create_time降序
    /**
     * @generated from protobuf field: int64 organization_group_id = 4
     */
    organizationGroupId: string; // 组织组id必须传
    /**
     * @generated from protobuf field: google.protobuf.StringValue organization_name = 5
     */
    organizationName?: StringValue; // 组织名称，可模糊查询
}
/**
 * @generated from protobuf message base.organization.ListOrganizationsRequest.OrderBy
 */
export interface ListOrganizationsRequest_OrderBy {
    /**
     * @generated from protobuf field: base.organization.ListOrganizationsRequest.Field field = 1
     */
    field: ListOrganizationsRequest_Field;
    /**
     * @generated from protobuf field: base.organization.ListOrganizationsRequest.Order order = 2
     */
    order: ListOrganizationsRequest_Order;
}
/**
 * @generated from protobuf enum base.organization.ListOrganizationsRequest.Field
 */
export enum ListOrganizationsRequest_Field {
    /**
     * @generated from protobuf enum value: FIELD_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FIELD_CREATE_TIME = 1;
     */
    CREATE_TIME = 1,
    /**
     * @generated from protobuf enum value: FIELD_UPDATE_TIME = 2;
     */
    UPDATE_TIME = 2
}
/**
 * @generated from protobuf enum base.organization.ListOrganizationsRequest.Order
 */
export enum ListOrganizationsRequest_Order {
    /**
     * @generated from protobuf enum value: ORDER_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ORDER_ASC = 1;
     */
    ASC = 1,
    /**
     * @generated from protobuf enum value: ORDER_DESC = 2;
     */
    DESC = 2
}
/**
 * @generated from protobuf message base.organization.ListOrganizationsResponse
 */
export interface ListOrganizationsResponse {
    /**
     * @generated from protobuf field: repeated base.organization.Organization organizations = 1
     */
    organizations: Organization[];
    /**
     * @generated from protobuf field: int64 total_elements = 2
     */
    totalElements: string;
    /**
     * @generated from protobuf field: int32 total_pages = 3
     */
    totalPages: number;
    /**
     * @generated from protobuf field: bool is_first = 4
     */
    isFirst: boolean;
    /**
     * @generated from protobuf field: bool is_last = 5
     */
    isLast: boolean;
    /**
     * @generated from protobuf field: int32 page_elements = 6
     */
    pageElements: number;
    /**
     * @generated from protobuf field: int32 page_num = 7
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 page_size = 8
     */
    pageSize: number;
}
/**
 * @generated from protobuf message base.organization.PageListAccountGroupAccountsResponse
 */
export interface PageListAccountGroupAccountsResponse {
    /**
     * @generated from protobuf field: repeated base.organization.AccountGroupAccount results = 1
     */
    results: AccountGroupAccount[];
    /**
     * @generated from protobuf field: int64 totalElements = 2
     */
    totalElements: string;
    /**
     * @generated from protobuf field: int32 totalPages = 3
     */
    totalPages: number;
    /**
     * @generated from protobuf field: bool isFirst = 4
     */
    isFirst: boolean;
    /**
     * @generated from protobuf field: bool isLast = 5
     */
    isLast: boolean;
    /**
     * @generated from protobuf field: int32 number = 6
     */
    number: number;
    /**
     * @generated from protobuf field: int32 numberOfElements = 7
     */
    numberOfElements: number;
    /**
     * @generated from protobuf field: int32 size = 8
     */
    size: number;
}
/**
 * @generated from protobuf message base.organization.PageListAccountGroupAccountsRequest
 */
export interface PageListAccountGroupAccountsRequest {
    /**
     * @generated from protobuf field: int32 pageNum = 1
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 pageSize = 2
     */
    pageSize: number;
    /**
     * 查询条件
     *
     * @generated from protobuf field: repeated int64 organizationIds = 3
     */
    organizationIds: string[]; // 组织ID
    /**
     * @generated from protobuf field: repeated int64 organizationGroupIds = 4
     */
    organizationGroupIds: string[]; // 组织组ID
    /**
     * @generated from protobuf field: repeated int64 accountIds = 5
     */
    accountIds: string[]; // 用户ID
}
/**
 * @generated from protobuf message base.organization.PageListOrganizationsResponse
 */
export interface PageListOrganizationsResponse {
    /**
     * @generated from protobuf field: repeated base.organization.OrganizationGroupList results = 1
     */
    results: OrganizationGroupList[];
    /**
     * @generated from protobuf field: int64 totalElements = 2
     */
    totalElements: string;
    /**
     * @generated from protobuf field: int32 totalPages = 3
     */
    totalPages: number;
    /**
     * @generated from protobuf field: bool isFirst = 4
     */
    isFirst: boolean;
    /**
     * @generated from protobuf field: bool isLast = 5
     */
    isLast: boolean;
    /**
     * @generated from protobuf field: int32 number = 6
     */
    number: number;
    /**
     * @generated from protobuf field: int32 numberOfElements = 7
     */
    numberOfElements: number;
    /**
     * @generated from protobuf field: int32 size = 8
     */
    size: number;
}
/**
 * @generated from protobuf message base.organization.PageListOrganizationsRequest
 */
export interface PageListOrganizationsRequest {
    /**
     * @generated from protobuf field: int32 pageNum = 1
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 pageSize = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: repeated int64 organizationGroupIds = 3
     */
    organizationGroupIds: string[];
}
/**
 * @generated from protobuf message base.organization.ListAccountsByOrganizationIdsAndAccountGroupNameResponse
 */
export interface ListAccountsByOrganizationIdsAndAccountGroupNameResponse {
    /**
     * @generated from protobuf field: repeated base.organization.OrganizationAccountGroupAccount organizationAccountGroupAccountList = 1
     */
    organizationAccountGroupAccountList: OrganizationAccountGroupAccount[];
}
/**
 * @generated from protobuf message base.organization.OrganizationAccountGroupAccount
 */
export interface OrganizationAccountGroupAccount {
    /**
     * @generated from protobuf field: base.organization.Organization organization = 1
     */
    organization?: Organization;
    /**
     * @generated from protobuf field: repeated base.organization.OrganizationAccountGroupAccount.AccountGroupAccount accountGroupAccountList = 2
     */
    accountGroupAccountList: OrganizationAccountGroupAccount_AccountGroupAccount[];
}
/**
 * @generated from protobuf message base.organization.OrganizationAccountGroupAccount.AccountGroupAccount
 */
export interface OrganizationAccountGroupAccount_AccountGroupAccount {
    /**
     * @generated from protobuf field: base.organization.AccountGroup accountGroup = 1
     */
    accountGroup?: AccountGroup;
    /**
     * @generated from protobuf field: repeated int64 accountIdList = 2
     */
    accountIdList: string[];
}
/**
 * @generated from protobuf message base.organization.ListAccountsByOrganizationIdsAndAccountGroupNameRequest
 */
export interface ListAccountsByOrganizationIdsAndAccountGroupNameRequest {
    /**
     * @generated from protobuf field: repeated int64 organizationIdList = 1
     */
    organizationIdList: string[];
    /**
     * @generated from protobuf field: repeated string accountGroupNameList = 2
     */
    accountGroupNameList: string[];
}
/**
 * @generated from protobuf message base.organization.GetOrganizationByOrganizationGroupIdResponse
 */
export interface GetOrganizationByOrganizationGroupIdResponse {
    /**
     * @generated from protobuf field: base.organization.Organization organization = 1
     */
    organization?: Organization;
}
/**
 * @generated from protobuf message base.organization.GetOrganizationByOrganizationGroupIdRequest
 */
export interface GetOrganizationByOrganizationGroupIdRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationGroupId = 1
     */
    organizationGroupId?: Int64Value;
}
/**
 * @generated from protobuf message base.organization.NewGetAccountGroupAccountsByOrganizationIdsRequest
 */
export interface NewGetAccountGroupAccountsByOrganizationIdsRequest {
    /**
     * @generated from protobuf field: repeated int64 organizationIds = 1
     */
    organizationIds: string[];
}
/**
 * @generated from protobuf message base.organization.NewGetAccountGroupAccountsByOrganizationIdsResponse
 */
export interface NewGetAccountGroupAccountsByOrganizationIdsResponse {
    /**
     * @generated from protobuf field: repeated base.organization.AccountGroupAccount accountGroupAccount = 1
     */
    accountGroupAccount: AccountGroupAccount[];
}
/**
 * @generated from protobuf message base.organization.AccountGroupAccount
 */
export interface AccountGroupAccount {
    /**
     * @generated from protobuf field: base.organization.Organization organization = 1
     */
    organization?: Organization;
    /**
     * @generated from protobuf field: repeated int64 accountId = 2
     */
    accountId: string[];
    /**
     * @generated from protobuf field: int64 creationTimestamp = 3
     */
    creationTimestamp: string;
}
/**
 * @generated from protobuf message base.organization.AddAccountToAccountGroupByAccountIdRequest
 */
export interface AddAccountToAccountGroupByAccountIdRequest {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * @generated from protobuf field: int64 accountGroupId = 2
     */
    accountGroupId: string;
}
/**
 * @generated from protobuf message base.organization.AddAccountToAccountGroupByAccountIdResponse
 */
export interface AddAccountToAccountGroupByAccountIdResponse {
    /**
     * @generated from protobuf field: bool done = 1
     */
    done: boolean;
}
/**
 * @generated from protobuf message base.organization.GetAccountGroupAccountsByOrganizationIdsRequest
 */
export interface GetAccountGroupAccountsByOrganizationIdsRequest {
    /**
     * @generated from protobuf field: repeated int64 organizationIds = 1
     */
    organizationIds: string[];
}
/**
 * @generated from protobuf message base.organization.GetAccountGroupAccountsByOrganizationIdsResponse
 */
export interface GetAccountGroupAccountsByOrganizationIdsResponse {
    /**
     * @generated from protobuf field: repeated int64 accountIds = 1
     */
    accountIds: string[];
}
/**
 * @generated from protobuf message base.organization.GetAccountByOrganizationIdRequest
 */
export interface GetAccountByOrganizationIdRequest {
    /**
     * @generated from protobuf field: int64 organizationId = 1
     */
    organizationId: string;
}
/**
 * @generated from protobuf message base.organization.GetAccountByOrganizationIdResponse
 */
export interface GetAccountByOrganizationIdResponse {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
}
/**
 * @generated from protobuf message base.organization.CreateOrganizationGroupRequest
 */
export interface CreateOrganizationGroupRequest {
    /**
     * @generated from protobuf field: base.organization.CreateOrganizationGroup createOrganizationGroup = 1
     */
    createOrganizationGroup?: CreateOrganizationGroup;
}
/**
 * @generated from protobuf message base.organization.CreateOrganizationGroupResponse
 */
export interface CreateOrganizationGroupResponse {
    /**
     * @generated from protobuf field: int64 organizationGroupId = 1
     */
    organizationGroupId: string;
}
/**
 * @generated from protobuf message base.organization.GetOrganizationByNameAndTypeRequest
 */
export interface GetOrganizationByNameAndTypeRequest {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: string type = 2
     */
    type: string;
}
/**
 * @generated from protobuf message base.organization.GetOrganizationByNameAndTypeResponse
 */
export interface GetOrganizationByNameAndTypeResponse {
    /**
     * @generated from protobuf field: base.organization.Organization organization = 1
     */
    organization?: Organization;
}
/**
 * @generated from protobuf message base.organization.UpdateOrganizationNameAndDescriptionRequest
 */
export interface UpdateOrganizationNameAndDescriptionRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 1
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue name = 2
     */
    name?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue description = 3
     */
    description?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue organizationLogo = 5
     */
    organizationLogo?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue display_name = 6
     */
    displayName?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.ListValue aliases = 7
     */
    aliases?: ListValue;
}
/**
 * @generated from protobuf message base.organization.UpdateOrganizationNameAndDescriptionResponse
 */
export interface UpdateOrganizationNameAndDescriptionResponse {
    /**
     * @generated from protobuf field: bool isUpdated = 1
     */
    isUpdated: boolean;
}
/**
 * @generated from protobuf message base.organization.UpdateOrganizationGroupNameAndDescriptionRequest
 */
export interface UpdateOrganizationGroupNameAndDescriptionRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationGroupId = 1
     */
    organizationGroupId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue name = 2
     */
    name?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue description = 3
     */
    description?: StringValue;
}
/**
 * @generated from protobuf message base.organization.UpdateOrganizationGroupNameAndDescriptionResponse
 */
export interface UpdateOrganizationGroupNameAndDescriptionResponse {
    /**
     * @generated from protobuf field: bool isUpdated = 1
     */
    isUpdated: boolean;
}
/**
 * @generated from protobuf message base.organization.CreateOrganizationRelationshipRequest
 */
export interface CreateOrganizationRelationshipRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 1
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value invatationOrganizationId = 2
     */
    invatationOrganizationId?: Int64Value;
}
/**
 * @generated from protobuf message base.organization.CreateOrganizationRelationshipResponse
 */
export interface CreateOrganizationRelationshipResponse {
    /**
     * @generated from protobuf field: int64 organizationRelationshipId = 1
     */
    organizationRelationshipId: string;
}
/**
 * @generated from protobuf message base.organization.DeleteOrganizationRelationshipRequest
 */
export interface DeleteOrganizationRelationshipRequest {
    /**
     * @generated from protobuf field: int64 organizationRelationshipId = 1
     */
    organizationRelationshipId: string;
}
/**
 * @generated from protobuf message base.organization.DeleteOrganizationRelationshipResponse
 */
export interface DeleteOrganizationRelationshipResponse {
    /**
     * @generated from protobuf field: bool isDeleted = 1
     */
    isDeleted: boolean;
}
/**
 * @generated from protobuf message base.organization.AlterDefaultOrganizationRelationshipRequest
 */
export interface AlterDefaultOrganizationRelationshipRequest {
    /**
     * @generated from protobuf field: int64 organizationRelationshipId = 1
     */
    organizationRelationshipId: string;
    /**
     * @generated from protobuf field: int64 invatationOrganizationId = 2
     */
    invatationOrganizationId: string;
}
/**
 * @generated from protobuf message base.organization.AlterDefaultOrganizationRelationshipResponse
 */
export interface AlterDefaultOrganizationRelationshipResponse {
    /**
     * @generated from protobuf field: bool isAlter = 1
     */
    isAlter: boolean;
}
/**
 * @generated from protobuf message base.organization.OrganizationRelationshipResult
 */
export interface OrganizationRelationshipResult {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 1
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value invatationOrganizationId = 2
     */
    invatationOrganizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.BoolValue isDefault = 3
     */
    isDefault?: BoolValue;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value id = 4
     */
    id?: Int64Value;
}
/**
 * @generated from protobuf message base.organization.GetOrganizationRelationshipByIdRequest
 */
export interface GetOrganizationRelationshipByIdRequest {
    /**
     * @generated from protobuf field: int64 organizationRelationshipId = 1
     */
    organizationRelationshipId: string;
}
/**
 * @generated from protobuf message base.organization.GetOrganizationRelationshipByIdResponse
 */
export interface GetOrganizationRelationshipByIdResponse {
    /**
     * @generated from protobuf field: base.organization.OrganizationRelationshipResult organizationRelationshipResult = 1
     */
    organizationRelationshipResult?: OrganizationRelationshipResult;
}
/**
 * @generated from protobuf message base.organization.GetOrganizationRelationshipListByOrganizationIdRequest
 */
export interface GetOrganizationRelationshipListByOrganizationIdRequest {
    /**
     * @generated from protobuf field: int64 organizationId = 1
     */
    organizationId: string;
}
/**
 * @generated from protobuf message base.organization.GetOrganizationRelationshipListByOrganizationIdResponse
 */
export interface GetOrganizationRelationshipListByOrganizationIdResponse {
    /**
     * @generated from protobuf field: repeated base.organization.OrganizationRelationshipResult organizationRelationshipResults = 1
     */
    organizationRelationshipResults: OrganizationRelationshipResult[];
}
/**
 * @generated from protobuf message base.organization.GetDefaultOrganizationRelationshipRequest
 */
export interface GetDefaultOrganizationRelationshipRequest {
    /**
     * @generated from protobuf field: int64 organizationId = 1
     */
    organizationId: string;
}
/**
 * @generated from protobuf message base.organization.GetDefaultOrganizationRelationshipResponse
 */
export interface GetDefaultOrganizationRelationshipResponse {
    /**
     * @generated from protobuf field: base.organization.OrganizationRelationshipResult organizationRelationshipResult = 1
     */
    organizationRelationshipResult?: OrganizationRelationshipResult;
}
/**
 * @generated from protobuf message base.organization.GetAccountGroupPermissionUUIDsRequest
 */
export interface GetAccountGroupPermissionUUIDsRequest {
    /**
     * @generated from protobuf field: repeated base.organization.OrganizationAccountGroup organizationAccountGroups = 1
     */
    organizationAccountGroups: OrganizationAccountGroup[];
}
/**
 * @generated from protobuf message base.organization.OrganizationAccountGroup
 */
export interface OrganizationAccountGroup {
    /**
     * @generated from protobuf field: int64 organizationId = 1
     */
    organizationId: string;
    /**
     * @generated from protobuf field: int64 accountGroupId = 2
     */
    accountGroupId: string;
}
/**
 * @generated from protobuf message base.organization.GetAccountGroupPermissionUUIDsResponse
 */
export interface GetAccountGroupPermissionUUIDsResponse {
    /**
     * @generated from protobuf field: repeated bytes permissionUUIDs = 1
     */
    permissionUUIDs: Uint8Array[];
}
/**
 * @generated from protobuf message base.organization.GetAccountGroupByAccountIdRequest
 */
export interface GetAccountGroupByAccountIdRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountId = 1
     */
    accountId?: Int64Value;
}
/**
 * @generated from protobuf message base.organization.GetAccountGroupByAccountIdResponse
 */
export interface GetAccountGroupByAccountIdResponse {
    /**
     * @generated from protobuf field: repeated base.organization.GetAccountGroupByAccountIdResponse.OrganizationAccountGroup accountGroup = 1
     */
    accountGroup: GetAccountGroupByAccountIdResponse_OrganizationAccountGroup[];
}
/**
 * @generated from protobuf message base.organization.GetAccountGroupByAccountIdResponse.OrganizationAccountGroup
 */
export interface GetAccountGroupByAccountIdResponse_OrganizationAccountGroup {
    /**
     * @generated from protobuf field: int64 organizationId = 1
     */
    organizationId: string;
    /**
     * @generated from protobuf field: repeated int64 accountGroupIds = 2
     */
    accountGroupIds: string[];
}
/**
 * @generated from protobuf message base.organization.DeleteAccountGroupPermissionResponse
 */
export interface DeleteAccountGroupPermissionResponse {
    /**
     * @generated from protobuf field: google.protobuf.BoolValue success = 1
     */
    success?: BoolValue;
}
/**
 * @generated from protobuf message base.organization.DeleteAccountGroupPermissionRequest
 */
export interface DeleteAccountGroupPermissionRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 1
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountGroupId = 2
     */
    accountGroupId?: Int64Value;
    /**
     * @generated from protobuf field: repeated string UUIDs = 3
     */
    uUIDs: string[];
}
/**
 * @generated from protobuf message base.organization.ListAccountGroupPermissionUUIDResponse
 */
export interface ListAccountGroupPermissionUUIDResponse {
    /**
     * @generated from protobuf field: repeated bytes permissionUUIDs = 1
     */
    permissionUUIDs: Uint8Array[];
}
/**
 * @generated from protobuf message base.organization.ListAccountGroupPermissionUUIDRequest
 */
export interface ListAccountGroupPermissionUUIDRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 1
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountGroupId = 2
     */
    accountGroupId?: Int64Value;
}
/**
 * @generated from protobuf message base.organization.ListAccountGroupPermissionResponse
 */
export interface ListAccountGroupPermissionResponse {
    /**
     * @generated from protobuf field: base.organization.AccountGroupPermission accountGroupPermission = 1
     */
    accountGroupPermission?: AccountGroupPermission;
}
/**
 * @generated from protobuf message base.organization.AccountGroupPermission
 */
export interface AccountGroupPermission {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 1
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountGroupId = 2
     */
    accountGroupId?: Int64Value;
    /**
     * @generated from protobuf field: repeated base.organization.Permission permission = 3
     */
    permission: Permission[];
}
/**
 * @generated from protobuf message base.organization.ListAccountGroupPermissionRequest
 */
export interface ListAccountGroupPermissionRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 1
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountGroupId = 2
     */
    accountGroupId?: Int64Value;
}
/**
 * @generated from protobuf message base.organization.AuthorizeToAccountGroupResponse
 */
export interface AuthorizeToAccountGroupResponse {
    /**
     * @generated from protobuf field: google.protobuf.BoolValue success = 1
     */
    success?: BoolValue;
}
/**
 * @generated from protobuf message base.organization.AuthorizeToAccountGroupRequest
 */
export interface AuthorizeToAccountGroupRequest {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationId = 1
     */
    organizationId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountGroupId = 2
     */
    accountGroupId?: Int64Value;
    /**
     * @generated from protobuf field: repeated string permissionUUIDs = 3
     */
    permissionUUIDs: string[];
}
/**
 * @generated from protobuf message base.organization.GetOrganizationByIdsRequest
 */
export interface GetOrganizationByIdsRequest {
    /**
     * @generated from protobuf field: repeated int64 ids = 1
     */
    ids: string[];
}
/**
 * @generated from protobuf message base.organization.GetOrganizationByIdsResponse
 */
export interface GetOrganizationByIdsResponse {
    /**
     * @generated from protobuf field: repeated base.organization.Organization organizations = 1
     */
    organizations: Organization[];
}
/**
 * @generated from protobuf message base.organization.GetOrganizationsByTypeRequest
 */
export interface GetOrganizationsByTypeRequest {
    /**
     * @generated from protobuf field: string type = 1
     */
    type: string;
}
/**
 * @generated from protobuf message base.organization.GetOrganizationsByTypeResponse
 */
export interface GetOrganizationsByTypeResponse {
    /**
     * @generated from protobuf field: repeated base.organization.Organization organizations = 1
     */
    organizations: Organization[];
}
/**
 * @generated from protobuf message base.organization.GetOrganizationOrganizationsRequest
 */
export interface GetOrganizationOrganizationsRequest {
    /**
     * @generated from protobuf field: int64 organizationId = 1
     */
    organizationId: string;
}
/**
 * @generated from protobuf message base.organization.GetOrganizationOrganizationsResponse
 */
export interface GetOrganizationOrganizationsResponse {
    /**
     * @generated from protobuf field: repeated base.organization.GetOrganizationOrganizationsResponse.OrganizationGroupInfo organizationGroups = 1
     */
    organizationGroups: GetOrganizationOrganizationsResponse_OrganizationGroupInfo[];
}
/**
 * @generated from protobuf message base.organization.GetOrganizationOrganizationsResponse.OrganizationGroupInfo
 */
export interface GetOrganizationOrganizationsResponse_OrganizationGroupInfo {
    /**
     * @generated from protobuf field: int64 organizationGroupId = 1
     */
    organizationGroupId: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @generated from protobuf field: repeated base.organization.GetOrganizationOrganizationsResponse.OrganizationInfo organizations = 4
     */
    organizations: GetOrganizationOrganizationsResponse_OrganizationInfo[];
}
/**
 * @generated from protobuf message base.organization.GetOrganizationOrganizationsResponse.OrganizationInfo
 */
export interface GetOrganizationOrganizationsResponse_OrganizationInfo {
    /**
     * @generated from protobuf field: int64 organizationId = 1
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @generated from protobuf field: repeated base.organization.GetOrganizationOrganizationsResponse.OrganizationGroupInfo organizationGroups = 4
     */
    organizationGroups: GetOrganizationOrganizationsResponse_OrganizationGroupInfo[];
}
/**
 * @generated from protobuf message base.organization.GetOrganizationParentOrganizationGroupRequest
 */
export interface GetOrganizationParentOrganizationGroupRequest {
    /**
     * @generated from protobuf field: int64 organizationId = 1
     */
    organizationId: string;
}
/**
 * @generated from protobuf message base.organization.GetOrganizationParentOrganizationGroupResponse
 */
export interface GetOrganizationParentOrganizationGroupResponse {
    /**
     * @generated from protobuf field: base.organization.OrganizationGroup organizationGroup = 1
     */
    organizationGroup?: OrganizationGroup;
}
/**
 * @generated from protobuf message base.organization.UpdateOrganizationsOrganizationGroupRequest
 */
export interface UpdateOrganizationsOrganizationGroupRequest {
    /**
     * @generated from protobuf field: repeated int64 organizationIds = 1
     */
    organizationIds: string[];
    /**
     * @generated from protobuf field: int64 organizationGroupId = 2
     */
    organizationGroupId: string;
}
/**
 * @generated from protobuf message base.organization.UpdateOrganizationsOrganizationGroupResponse
 */
export interface UpdateOrganizationsOrganizationGroupResponse {
    /**
     * @generated from protobuf field: bool done = 1
     */
    done: boolean;
}
/**
 * @generated from protobuf message base.organization.GetOrganizationsByOrganizationGroupIdsRequest
 */
export interface GetOrganizationsByOrganizationGroupIdsRequest {
    /**
     * @generated from protobuf field: repeated int64 organizationGroupIds = 1
     */
    organizationGroupIds: string[];
}
/**
 * @generated from protobuf message base.organization.GetOrganizationsByOrganizationGroupIdsResponse
 */
export interface GetOrganizationsByOrganizationGroupIdsResponse {
    /**
     * @generated from protobuf field: repeated base.organization.OrganizationGroupList organizationGroupList = 1
     */
    organizationGroupList: OrganizationGroupList[];
}
/**
 * @generated from protobuf message base.organization.OrganizationGroupList
 */
export interface OrganizationGroupList {
    /**
     * @generated from protobuf field: int64 organizationGroupId = 1
     */
    organizationGroupId: string;
    /**
     * @generated from protobuf field: repeated base.organization.Organization organizationList = 2
     */
    organizationList: Organization[];
}
/**
 * @generated from protobuf message base.organization.Organization
 */
export interface Organization {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * @generated from protobuf field: int64 id = 3
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue type = 4
     */
    type?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue organizationLogo = 5
     */
    organizationLogo?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value creationTimestamp = 6
     */
    creationTimestamp?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value parentOrganizationGroupId = 7
     */
    parentOrganizationGroupId?: Int64Value;
    /**
     * @generated from protobuf field: repeated string aliases = 8
     */
    aliases: string[];
}
/**
 * @generated from protobuf message base.organization.GetOrganizationGroupsByOrganizationIdRequest
 */
export interface GetOrganizationGroupsByOrganizationIdRequest {
    /**
     * @generated from protobuf field: int64 organizationId = 1
     */
    organizationId: string;
}
/**
 * @generated from protobuf message base.organization.GetOrganizationGroupsByOrganizationIdResponse
 */
export interface GetOrganizationGroupsByOrganizationIdResponse {
    /**
     * @generated from protobuf field: repeated base.organization.OrganizationGroup organizationGroups = 1
     */
    organizationGroups: OrganizationGroup[];
}
/**
 * @generated from protobuf message base.organization.OrganizationGroup
 */
export interface OrganizationGroup {
    /**
     * @generated from protobuf field: int64 id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
}
/**
 * @generated from protobuf message base.organization.GetAccountGroupContextRequest
 */
export interface GetAccountGroupContextRequest {
}
/**
 * @generated from protobuf message base.organization.GetAccountGroupContextResponse
 */
export interface GetAccountGroupContextResponse {
    /**
     * @generated from protobuf field: repeated base.organization.AccountGroupContext accountGroups = 1
     */
    accountGroups: AccountGroupContext[];
}
/**
 * @generated from protobuf message base.organization.AccountGroupContext
 */
export interface AccountGroupContext {
    /**
     * @generated from protobuf field: int64 id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @generated from protobuf field: int64 organizationId = 4
     */
    organizationId: string;
}
/**
 * @generated from protobuf message base.organization.GetOrganizationContextRequest
 */
export interface GetOrganizationContextRequest {
    /**
     * @generated from protobuf field: base.organization.OrganizationType type = 1
     */
    type: OrganizationType;
}
/**
 * @generated from protobuf message base.organization.GetOrganizationContextResponse
 */
export interface GetOrganizationContextResponse {
    /**
     * @generated from protobuf field: repeated base.OrganizationContext organizationContext = 1
     */
    organizationContext: OrganizationContext[];
}
/**
 * @generated from protobuf message base.organization.GetAccountPermissionRequest
 */
export interface GetAccountPermissionRequest {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
}
/**
 * @generated from protobuf message base.organization.GetAccountPermissionResponse
 */
export interface GetAccountPermissionResponse {
    /**
     * @generated from protobuf field: repeated base.OrganizationContext organizationContext = 1
     */
    organizationContext: OrganizationContext[];
}
/**
 * @generated from protobuf message base.organization.AcceptUserInvitationRequest
 */
export interface AcceptUserInvitationRequest {
    /**
     * @generated from protobuf field: string uuid = 1
     */
    uuid: string;
}
/**
 * @generated from protobuf message base.organization.AcceptUserInvitationResponse
 */
export interface AcceptUserInvitationResponse {
    /**
     * @generated from protobuf field: bool isAccepted = 1
     */
    isAccepted: boolean;
}
/**
 * @generated from protobuf message base.organization.GetUserGroupInvitationUuidRequest
 */
export interface GetUserGroupInvitationUuidRequest {
    /**
     * @generated from protobuf field: int64 organizationId = 1
     */
    organizationId: string;
    /**
     * @generated from protobuf field: int64 accountGroupId = 2
     */
    accountGroupId: string;
    /**
     * @generated from protobuf field: int32 count = 3
     */
    count: number;
}
/**
 * @generated from protobuf message base.organization.GetUserGroupInvitationUuidResponse
 */
export interface GetUserGroupInvitationUuidResponse {
    /**
     * @generated from protobuf field: string uuid = 1
     */
    uuid: string;
}
/**
 * @generated from protobuf message base.organization.GetAccountGroupRequest
 */
export interface GetAccountGroupRequest {
    /**
     * @generated from protobuf field: int64 organizationId = 1
     */
    organizationId: string;
}
/**
 * @generated from protobuf message base.organization.GetAccountGroupResponse
 */
export interface GetAccountGroupResponse {
    /**
     * @generated from protobuf field: repeated base.organization.AccountGroup accountGroup = 1
     */
    accountGroup: AccountGroup[];
}
/**
 * @generated from protobuf message base.organization.AccountGroup
 */
export interface AccountGroup {
    /**
     * @generated from protobuf field: int64 id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string; // 名称，用于查询，尽量使用英文
    /**
     * @generated from protobuf field: string displayName = 3
     */
    displayName: string; // 昵称，用于显示
    /**
     * @generated from protobuf field: string description = 4
     */
    description: string;
    /**
     * @generated from protobuf field: int32 account_count = 5
     */
    accountCount: number;
}
/**
 * @generated from protobuf message base.organization.GetAccountGroupAccountRequest
 */
export interface GetAccountGroupAccountRequest {
    /**
     * @generated from protobuf field: int64 organizationId = 1
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
}
/**
 * @generated from protobuf message base.organization.GetAccountGroupAccountResponse
 */
export interface GetAccountGroupAccountResponse {
    /**
     * @generated from protobuf field: repeated int64 organizationAccountId = 1
     */
    organizationAccountId: string[];
}
/**
 * @generated from protobuf message base.organization.RemoveAccountFromAccountGroupRequest
 */
export interface RemoveAccountFromAccountGroupRequest {
    /**
     * @generated from protobuf field: int64 accountGroupId = 1
     */
    accountGroupId: string;
    /**
     * @generated from protobuf field: int64 accountId = 2
     */
    accountId: string;
}
/**
 * @generated from protobuf message base.organization.RemoveAccountFromAccountGroupResponse
 */
export interface RemoveAccountFromAccountGroupResponse {
    /**
     * @generated from protobuf field: bool isRemoved = 1
     */
    isRemoved: boolean;
}
/**
 * @generated from protobuf message base.organization.AddAccountToAccountGroupRequest
 */
export interface AddAccountToAccountGroupRequest {
    /**
     * @generated from protobuf field: int64 accountGroupId = 1
     */
    accountGroupId: string;
}
/**
 * @generated from protobuf message base.organization.AddAccountToAccountGroupResponse
 */
export interface AddAccountToAccountGroupResponse {
    /**
     * @generated from protobuf field: bool isAdded = 1
     */
    isAdded: boolean;
}
/**
 * todo 是否需要删除下面的组员
 *
 * @generated from protobuf message base.organization.DeletedAccountGroupRequest
 */
export interface DeletedAccountGroupRequest {
}
/**
 * @generated from protobuf message base.organization.DeletedAccountGroupResponse
 */
export interface DeletedAccountGroupResponse {
}
/**
 * @generated from protobuf message base.organization.CreateAccountGroupRequest
 */
export interface CreateAccountGroupRequest {
    /**
     * @generated from protobuf field: base.organization.CreateAccountGroup createAccountGroup = 1
     */
    createAccountGroup?: CreateAccountGroup;
}
/**
 * @generated from protobuf message base.organization.CreateAccountGroup
 */
export interface CreateAccountGroup {
    /**
     * @generated from protobuf field: int64 organizationId = 1
     */
    organizationId: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string; // 名称，用于查询，尽量使用英文
    /**
     * @generated from protobuf field: string displayName = 3
     */
    displayName: string; // 昵称，用于显示
    /**
     * @generated from protobuf field: string description = 4
     */
    description: string;
    /**
     * @generated from protobuf field: int32 account_count = 5
     */
    accountCount: number;
}
/**
 * @generated from protobuf message base.organization.CreateAccountGroupResponse
 */
export interface CreateAccountGroupResponse {
    /**
     * @generated from protobuf field: int64 accountGroupId = 1
     */
    accountGroupId: string;
}
/**
 * @generated from protobuf message base.organization.UpdateAccountGroupRequest
 */
export interface UpdateAccountGroupRequest {
    /**
     * @generated from protobuf field: int64 account_group_id = 1
     */
    accountGroupId: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string display_name = 3
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 4
     */
    description: string;
    /**
     * @generated from protobuf field: int32 account_count = 5
     */
    accountCount: number;
}
/**
 * @generated from protobuf message base.organization.UpdateAccountGroupResponse
 */
export interface UpdateAccountGroupResponse {
    /**
     * @generated from protobuf field: int64 account_group_id = 1
     */
    accountGroupId: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string display_name = 3
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 4
     */
    description: string;
    /**
     * @generated from protobuf field: int32 account_count = 5
     */
    accountCount: number;
    /**
     * @generated from protobuf field: int64 organization_id = 6
     */
    organizationId: string;
}
/**
 * @generated from protobuf message base.organization.CreateOrganizationGroup
 */
export interface CreateOrganizationGroup {
    /**
     * @generated from protobuf field: int64 parentOrganizationId = 1
     */
    parentOrganizationId: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
}
/**
 * @generated from protobuf message base.organization.DeleteOrganizationRequest
 */
export interface DeleteOrganizationRequest {
    /**
     * @generated from protobuf field: int64 organizationId = 1
     */
    organizationId: string;
}
/**
 * @generated from protobuf message base.organization.DeleteOrganizationResponse
 */
export interface DeleteOrganizationResponse {
    /**
     * @generated from protobuf field: bool isDeleted = 1
     */
    isDeleted: boolean;
}
/**
 * @generated from protobuf message base.organization.CreateOrganizationRequest
 */
export interface CreateOrganizationRequest {
    /**
     * @generated from protobuf field: base.organization.CreateOrganization createOrganization = 1
     */
    createOrganization?: CreateOrganization;
}
/**
 * @generated from protobuf message base.organization.CreateOrganizationResponse
 */
export interface CreateOrganizationResponse {
    /**
     * @generated from protobuf field: int64 organizationId = 1
     */
    organizationId: string;
}
/**
 * @generated from protobuf message base.organization.CreateOrganization
 */
export interface CreateOrganization {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value organizationGroupId = 1
     */
    organizationGroupId?: Int64Value;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue type = 4
     */
    type?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue organizationLogo = 5
     */
    organizationLogo?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue display_name = 6
     */
    displayName?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.ListValue aliases = 7
     */
    aliases?: ListValue;
}
/**
 * @generated from protobuf message base.organization.CheckOrganizationRequest
 */
export interface CheckOrganizationRequest {
    /**
     * 组织id
     *
     * @generated from protobuf field: int64 organizationId = 1
     */
    organizationId: string;
}
/**
 * @generated from protobuf message base.organization.CheckOrganizationResponse
 */
export interface CheckOrganizationResponse {
    /**
     * @generated from protobuf field: bool status = 1
     */
    status: boolean;
}
/**
 * @generated from protobuf message base.organization.GetPresignedPutObjectUrlRequest
 */
export interface GetPresignedPutObjectUrlRequest {
    /**
     * @generated from protobuf field: string object_type = 1
     */
    objectType: string;
    /**
     * @generated from protobuf field: string key = 2
     */
    key: string;
}
/**
 * @generated from protobuf message base.organization.GetPresignedPutObjectUrlResponse
 */
export interface GetPresignedPutObjectUrlResponse {
    /**
     * @generated from protobuf field: string key = 1
     */
    key: string;
    /**
     * @generated from protobuf field: string url = 2
     */
    url: string;
}
/**
 * @generated from protobuf enum base.organization.OrganizationType
 */
export enum OrganizationType {
    /**
     * @generated from protobuf enum value: EULER = 0;
     */
    EULER = 0,
    /**
     * @generated from protobuf enum value: STUDIO = 1;
     */
    STUDIO = 1
}
// @generated message type with reflection information, may provide speed optimized methods
class ListOrganizationByAccountIdResponse$Type extends MessageType<ListOrganizationByAccountIdResponse> {
    constructor() {
        super("base.organization.ListOrganizationByAccountIdResponse", [
            { no: 1, name: "organizations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Organization }
        ]);
    }
    create(value?: PartialMessage<ListOrganizationByAccountIdResponse>): ListOrganizationByAccountIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizations = [];
        if (value !== undefined)
            reflectionMergePartial<ListOrganizationByAccountIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListOrganizationByAccountIdResponse): ListOrganizationByAccountIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.organization.Organization organizations */ 1:
                    message.organizations.push(Organization.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListOrganizationByAccountIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.organization.Organization organizations = 1; */
        for (let i = 0; i < message.organizations.length; i++)
            Organization.internalBinaryWrite(message.organizations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.ListOrganizationByAccountIdResponse
 */
export const ListOrganizationByAccountIdResponse = new ListOrganizationByAccountIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOrganizationByAccountIdRequest$Type extends MessageType<ListOrganizationByAccountIdRequest> {
    constructor() {
        super("base.organization.ListOrganizationByAccountIdRequest", [
            { no: 1, name: "accountId", kind: "message", T: () => Int64Value },
            { no: 2, name: "type", kind: "message", T: () => StringValue },
            { no: 3, name: "name", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<ListOrganizationByAccountIdRequest>): ListOrganizationByAccountIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListOrganizationByAccountIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListOrganizationByAccountIdRequest): ListOrganizationByAccountIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value accountId */ 1:
                    message.accountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                case /* google.protobuf.StringValue type */ 2:
                    message.type = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.type);
                    break;
                case /* google.protobuf.StringValue name */ 3:
                    message.name = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.name);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListOrganizationByAccountIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value accountId = 1; */
        if (message.accountId)
            Int64Value.internalBinaryWrite(message.accountId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue type = 2; */
        if (message.type)
            StringValue.internalBinaryWrite(message.type, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue name = 3; */
        if (message.name)
            StringValue.internalBinaryWrite(message.name, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.ListOrganizationByAccountIdRequest
 */
export const ListOrganizationByAccountIdRequest = new ListOrganizationByAccountIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOrganizationsRequest$Type extends MessageType<ListOrganizationsRequest> {
    constructor() {
        super("base.organization.ListOrganizationsRequest", [
            { no: 1, name: "page_num", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "order_by", kind: "message", T: () => ListOrganizationsRequest_OrderBy },
            { no: 4, name: "organization_group_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 5, name: "organization_name", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<ListOrganizationsRequest>): ListOrganizationsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageNum = 0;
        message.pageSize = 0;
        message.organizationGroupId = "0";
        if (value !== undefined)
            reflectionMergePartial<ListOrganizationsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListOrganizationsRequest): ListOrganizationsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_num */ 1:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* base.organization.ListOrganizationsRequest.OrderBy order_by */ 3:
                    message.orderBy = ListOrganizationsRequest_OrderBy.internalBinaryRead(reader, reader.uint32(), options, message.orderBy);
                    break;
                case /* int64 organization_group_id */ 4:
                    message.organizationGroupId = reader.int64().toString();
                    break;
                case /* google.protobuf.StringValue organization_name */ 5:
                    message.organizationName = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.organizationName);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListOrganizationsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_num = 1; */
        if (message.pageNum !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageNum);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* base.organization.ListOrganizationsRequest.OrderBy order_by = 3; */
        if (message.orderBy)
            ListOrganizationsRequest_OrderBy.internalBinaryWrite(message.orderBy, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* int64 organization_group_id = 4; */
        if (message.organizationGroupId !== "0")
            writer.tag(4, WireType.Varint).int64(message.organizationGroupId);
        /* google.protobuf.StringValue organization_name = 5; */
        if (message.organizationName)
            StringValue.internalBinaryWrite(message.organizationName, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.ListOrganizationsRequest
 */
export const ListOrganizationsRequest = new ListOrganizationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOrganizationsRequest_OrderBy$Type extends MessageType<ListOrganizationsRequest_OrderBy> {
    constructor() {
        super("base.organization.ListOrganizationsRequest.OrderBy", [
            { no: 1, name: "field", kind: "enum", T: () => ["base.organization.ListOrganizationsRequest.Field", ListOrganizationsRequest_Field, "FIELD_"] },
            { no: 2, name: "order", kind: "enum", T: () => ["base.organization.ListOrganizationsRequest.Order", ListOrganizationsRequest_Order, "ORDER_"] }
        ]);
    }
    create(value?: PartialMessage<ListOrganizationsRequest_OrderBy>): ListOrganizationsRequest_OrderBy {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.field = 0;
        message.order = 0;
        if (value !== undefined)
            reflectionMergePartial<ListOrganizationsRequest_OrderBy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListOrganizationsRequest_OrderBy): ListOrganizationsRequest_OrderBy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.organization.ListOrganizationsRequest.Field field */ 1:
                    message.field = reader.int32();
                    break;
                case /* base.organization.ListOrganizationsRequest.Order order */ 2:
                    message.order = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListOrganizationsRequest_OrderBy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.organization.ListOrganizationsRequest.Field field = 1; */
        if (message.field !== 0)
            writer.tag(1, WireType.Varint).int32(message.field);
        /* base.organization.ListOrganizationsRequest.Order order = 2; */
        if (message.order !== 0)
            writer.tag(2, WireType.Varint).int32(message.order);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.ListOrganizationsRequest.OrderBy
 */
export const ListOrganizationsRequest_OrderBy = new ListOrganizationsRequest_OrderBy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOrganizationsResponse$Type extends MessageType<ListOrganizationsResponse> {
    constructor() {
        super("base.organization.ListOrganizationsResponse", [
            { no: 1, name: "organizations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Organization },
            { no: 2, name: "total_elements", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "total_pages", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "is_first", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "is_last", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "page_elements", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "page_num", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ListOrganizationsResponse>): ListOrganizationsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizations = [];
        message.totalElements = "0";
        message.totalPages = 0;
        message.isFirst = false;
        message.isLast = false;
        message.pageElements = 0;
        message.pageNum = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<ListOrganizationsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListOrganizationsResponse): ListOrganizationsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.organization.Organization organizations */ 1:
                    message.organizations.push(Organization.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 total_elements */ 2:
                    message.totalElements = reader.int64().toString();
                    break;
                case /* int32 total_pages */ 3:
                    message.totalPages = reader.int32();
                    break;
                case /* bool is_first */ 4:
                    message.isFirst = reader.bool();
                    break;
                case /* bool is_last */ 5:
                    message.isLast = reader.bool();
                    break;
                case /* int32 page_elements */ 6:
                    message.pageElements = reader.int32();
                    break;
                case /* int32 page_num */ 7:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 page_size */ 8:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListOrganizationsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.organization.Organization organizations = 1; */
        for (let i = 0; i < message.organizations.length; i++)
            Organization.internalBinaryWrite(message.organizations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 total_elements = 2; */
        if (message.totalElements !== "0")
            writer.tag(2, WireType.Varint).int64(message.totalElements);
        /* int32 total_pages = 3; */
        if (message.totalPages !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalPages);
        /* bool is_first = 4; */
        if (message.isFirst !== false)
            writer.tag(4, WireType.Varint).bool(message.isFirst);
        /* bool is_last = 5; */
        if (message.isLast !== false)
            writer.tag(5, WireType.Varint).bool(message.isLast);
        /* int32 page_elements = 6; */
        if (message.pageElements !== 0)
            writer.tag(6, WireType.Varint).int32(message.pageElements);
        /* int32 page_num = 7; */
        if (message.pageNum !== 0)
            writer.tag(7, WireType.Varint).int32(message.pageNum);
        /* int32 page_size = 8; */
        if (message.pageSize !== 0)
            writer.tag(8, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.ListOrganizationsResponse
 */
export const ListOrganizationsResponse = new ListOrganizationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PageListAccountGroupAccountsResponse$Type extends MessageType<PageListAccountGroupAccountsResponse> {
    constructor() {
        super("base.organization.PageListAccountGroupAccountsResponse", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccountGroupAccount },
            { no: 2, name: "totalElements", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "totalPages", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "isFirst", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "isLast", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "numberOfElements", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<PageListAccountGroupAccountsResponse>): PageListAccountGroupAccountsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.totalElements = "0";
        message.totalPages = 0;
        message.isFirst = false;
        message.isLast = false;
        message.number = 0;
        message.numberOfElements = 0;
        message.size = 0;
        if (value !== undefined)
            reflectionMergePartial<PageListAccountGroupAccountsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PageListAccountGroupAccountsResponse): PageListAccountGroupAccountsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.organization.AccountGroupAccount results */ 1:
                    message.results.push(AccountGroupAccount.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 totalElements */ 2:
                    message.totalElements = reader.int64().toString();
                    break;
                case /* int32 totalPages */ 3:
                    message.totalPages = reader.int32();
                    break;
                case /* bool isFirst */ 4:
                    message.isFirst = reader.bool();
                    break;
                case /* bool isLast */ 5:
                    message.isLast = reader.bool();
                    break;
                case /* int32 number */ 6:
                    message.number = reader.int32();
                    break;
                case /* int32 numberOfElements */ 7:
                    message.numberOfElements = reader.int32();
                    break;
                case /* int32 size */ 8:
                    message.size = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PageListAccountGroupAccountsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.organization.AccountGroupAccount results = 1; */
        for (let i = 0; i < message.results.length; i++)
            AccountGroupAccount.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 totalElements = 2; */
        if (message.totalElements !== "0")
            writer.tag(2, WireType.Varint).int64(message.totalElements);
        /* int32 totalPages = 3; */
        if (message.totalPages !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalPages);
        /* bool isFirst = 4; */
        if (message.isFirst !== false)
            writer.tag(4, WireType.Varint).bool(message.isFirst);
        /* bool isLast = 5; */
        if (message.isLast !== false)
            writer.tag(5, WireType.Varint).bool(message.isLast);
        /* int32 number = 6; */
        if (message.number !== 0)
            writer.tag(6, WireType.Varint).int32(message.number);
        /* int32 numberOfElements = 7; */
        if (message.numberOfElements !== 0)
            writer.tag(7, WireType.Varint).int32(message.numberOfElements);
        /* int32 size = 8; */
        if (message.size !== 0)
            writer.tag(8, WireType.Varint).int32(message.size);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.PageListAccountGroupAccountsResponse
 */
export const PageListAccountGroupAccountsResponse = new PageListAccountGroupAccountsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PageListAccountGroupAccountsRequest$Type extends MessageType<PageListAccountGroupAccountsRequest> {
    constructor() {
        super("base.organization.PageListAccountGroupAccountsRequest", [
            { no: 1, name: "pageNum", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "pageSize", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "organizationIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "organizationGroupIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ },
            { no: 5, name: "accountIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<PageListAccountGroupAccountsRequest>): PageListAccountGroupAccountsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageNum = 0;
        message.pageSize = 0;
        message.organizationIds = [];
        message.organizationGroupIds = [];
        message.accountIds = [];
        if (value !== undefined)
            reflectionMergePartial<PageListAccountGroupAccountsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PageListAccountGroupAccountsRequest): PageListAccountGroupAccountsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 pageNum */ 1:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 pageSize */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* repeated int64 organizationIds */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.organizationIds.push(reader.int64().toString());
                    else
                        message.organizationIds.push(reader.int64().toString());
                    break;
                case /* repeated int64 organizationGroupIds */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.organizationGroupIds.push(reader.int64().toString());
                    else
                        message.organizationGroupIds.push(reader.int64().toString());
                    break;
                case /* repeated int64 accountIds */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountIds.push(reader.int64().toString());
                    else
                        message.accountIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PageListAccountGroupAccountsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 pageNum = 1; */
        if (message.pageNum !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageNum);
        /* int32 pageSize = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* repeated int64 organizationIds = 3; */
        if (message.organizationIds.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.organizationIds.length; i++)
                writer.int64(message.organizationIds[i]);
            writer.join();
        }
        /* repeated int64 organizationGroupIds = 4; */
        if (message.organizationGroupIds.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.organizationGroupIds.length; i++)
                writer.int64(message.organizationGroupIds[i]);
            writer.join();
        }
        /* repeated int64 accountIds = 5; */
        if (message.accountIds.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountIds.length; i++)
                writer.int64(message.accountIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.PageListAccountGroupAccountsRequest
 */
export const PageListAccountGroupAccountsRequest = new PageListAccountGroupAccountsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PageListOrganizationsResponse$Type extends MessageType<PageListOrganizationsResponse> {
    constructor() {
        super("base.organization.PageListOrganizationsResponse", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrganizationGroupList },
            { no: 2, name: "totalElements", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "totalPages", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "isFirst", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "isLast", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "numberOfElements", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<PageListOrganizationsResponse>): PageListOrganizationsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.results = [];
        message.totalElements = "0";
        message.totalPages = 0;
        message.isFirst = false;
        message.isLast = false;
        message.number = 0;
        message.numberOfElements = 0;
        message.size = 0;
        if (value !== undefined)
            reflectionMergePartial<PageListOrganizationsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PageListOrganizationsResponse): PageListOrganizationsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.organization.OrganizationGroupList results */ 1:
                    message.results.push(OrganizationGroupList.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 totalElements */ 2:
                    message.totalElements = reader.int64().toString();
                    break;
                case /* int32 totalPages */ 3:
                    message.totalPages = reader.int32();
                    break;
                case /* bool isFirst */ 4:
                    message.isFirst = reader.bool();
                    break;
                case /* bool isLast */ 5:
                    message.isLast = reader.bool();
                    break;
                case /* int32 number */ 6:
                    message.number = reader.int32();
                    break;
                case /* int32 numberOfElements */ 7:
                    message.numberOfElements = reader.int32();
                    break;
                case /* int32 size */ 8:
                    message.size = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PageListOrganizationsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.organization.OrganizationGroupList results = 1; */
        for (let i = 0; i < message.results.length; i++)
            OrganizationGroupList.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 totalElements = 2; */
        if (message.totalElements !== "0")
            writer.tag(2, WireType.Varint).int64(message.totalElements);
        /* int32 totalPages = 3; */
        if (message.totalPages !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalPages);
        /* bool isFirst = 4; */
        if (message.isFirst !== false)
            writer.tag(4, WireType.Varint).bool(message.isFirst);
        /* bool isLast = 5; */
        if (message.isLast !== false)
            writer.tag(5, WireType.Varint).bool(message.isLast);
        /* int32 number = 6; */
        if (message.number !== 0)
            writer.tag(6, WireType.Varint).int32(message.number);
        /* int32 numberOfElements = 7; */
        if (message.numberOfElements !== 0)
            writer.tag(7, WireType.Varint).int32(message.numberOfElements);
        /* int32 size = 8; */
        if (message.size !== 0)
            writer.tag(8, WireType.Varint).int32(message.size);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.PageListOrganizationsResponse
 */
export const PageListOrganizationsResponse = new PageListOrganizationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PageListOrganizationsRequest$Type extends MessageType<PageListOrganizationsRequest> {
    constructor() {
        super("base.organization.PageListOrganizationsRequest", [
            { no: 1, name: "pageNum", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "pageSize", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "organizationGroupIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<PageListOrganizationsRequest>): PageListOrganizationsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageNum = 0;
        message.pageSize = 0;
        message.organizationGroupIds = [];
        if (value !== undefined)
            reflectionMergePartial<PageListOrganizationsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PageListOrganizationsRequest): PageListOrganizationsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 pageNum */ 1:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 pageSize */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* repeated int64 organizationGroupIds */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.organizationGroupIds.push(reader.int64().toString());
                    else
                        message.organizationGroupIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PageListOrganizationsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 pageNum = 1; */
        if (message.pageNum !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageNum);
        /* int32 pageSize = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* repeated int64 organizationGroupIds = 3; */
        if (message.organizationGroupIds.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.organizationGroupIds.length; i++)
                writer.int64(message.organizationGroupIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.PageListOrganizationsRequest
 */
export const PageListOrganizationsRequest = new PageListOrganizationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAccountsByOrganizationIdsAndAccountGroupNameResponse$Type extends MessageType<ListAccountsByOrganizationIdsAndAccountGroupNameResponse> {
    constructor() {
        super("base.organization.ListAccountsByOrganizationIdsAndAccountGroupNameResponse", [
            { no: 1, name: "organizationAccountGroupAccountList", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrganizationAccountGroupAccount }
        ]);
    }
    create(value?: PartialMessage<ListAccountsByOrganizationIdsAndAccountGroupNameResponse>): ListAccountsByOrganizationIdsAndAccountGroupNameResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationAccountGroupAccountList = [];
        if (value !== undefined)
            reflectionMergePartial<ListAccountsByOrganizationIdsAndAccountGroupNameResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAccountsByOrganizationIdsAndAccountGroupNameResponse): ListAccountsByOrganizationIdsAndAccountGroupNameResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.organization.OrganizationAccountGroupAccount organizationAccountGroupAccountList */ 1:
                    message.organizationAccountGroupAccountList.push(OrganizationAccountGroupAccount.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAccountsByOrganizationIdsAndAccountGroupNameResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.organization.OrganizationAccountGroupAccount organizationAccountGroupAccountList = 1; */
        for (let i = 0; i < message.organizationAccountGroupAccountList.length; i++)
            OrganizationAccountGroupAccount.internalBinaryWrite(message.organizationAccountGroupAccountList[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.ListAccountsByOrganizationIdsAndAccountGroupNameResponse
 */
export const ListAccountsByOrganizationIdsAndAccountGroupNameResponse = new ListAccountsByOrganizationIdsAndAccountGroupNameResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationAccountGroupAccount$Type extends MessageType<OrganizationAccountGroupAccount> {
    constructor() {
        super("base.organization.OrganizationAccountGroupAccount", [
            { no: 1, name: "organization", kind: "message", T: () => Organization },
            { no: 2, name: "accountGroupAccountList", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrganizationAccountGroupAccount_AccountGroupAccount }
        ]);
    }
    create(value?: PartialMessage<OrganizationAccountGroupAccount>): OrganizationAccountGroupAccount {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountGroupAccountList = [];
        if (value !== undefined)
            reflectionMergePartial<OrganizationAccountGroupAccount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrganizationAccountGroupAccount): OrganizationAccountGroupAccount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.organization.Organization organization */ 1:
                    message.organization = Organization.internalBinaryRead(reader, reader.uint32(), options, message.organization);
                    break;
                case /* repeated base.organization.OrganizationAccountGroupAccount.AccountGroupAccount accountGroupAccountList */ 2:
                    message.accountGroupAccountList.push(OrganizationAccountGroupAccount_AccountGroupAccount.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrganizationAccountGroupAccount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.organization.Organization organization = 1; */
        if (message.organization)
            Organization.internalBinaryWrite(message.organization, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated base.organization.OrganizationAccountGroupAccount.AccountGroupAccount accountGroupAccountList = 2; */
        for (let i = 0; i < message.accountGroupAccountList.length; i++)
            OrganizationAccountGroupAccount_AccountGroupAccount.internalBinaryWrite(message.accountGroupAccountList[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.OrganizationAccountGroupAccount
 */
export const OrganizationAccountGroupAccount = new OrganizationAccountGroupAccount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationAccountGroupAccount_AccountGroupAccount$Type extends MessageType<OrganizationAccountGroupAccount_AccountGroupAccount> {
    constructor() {
        super("base.organization.OrganizationAccountGroupAccount.AccountGroupAccount", [
            { no: 1, name: "accountGroup", kind: "message", T: () => AccountGroup },
            { no: 2, name: "accountIdList", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<OrganizationAccountGroupAccount_AccountGroupAccount>): OrganizationAccountGroupAccount_AccountGroupAccount {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountIdList = [];
        if (value !== undefined)
            reflectionMergePartial<OrganizationAccountGroupAccount_AccountGroupAccount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrganizationAccountGroupAccount_AccountGroupAccount): OrganizationAccountGroupAccount_AccountGroupAccount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.organization.AccountGroup accountGroup */ 1:
                    message.accountGroup = AccountGroup.internalBinaryRead(reader, reader.uint32(), options, message.accountGroup);
                    break;
                case /* repeated int64 accountIdList */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountIdList.push(reader.int64().toString());
                    else
                        message.accountIdList.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrganizationAccountGroupAccount_AccountGroupAccount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.organization.AccountGroup accountGroup = 1; */
        if (message.accountGroup)
            AccountGroup.internalBinaryWrite(message.accountGroup, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated int64 accountIdList = 2; */
        if (message.accountIdList.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountIdList.length; i++)
                writer.int64(message.accountIdList[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.OrganizationAccountGroupAccount.AccountGroupAccount
 */
export const OrganizationAccountGroupAccount_AccountGroupAccount = new OrganizationAccountGroupAccount_AccountGroupAccount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAccountsByOrganizationIdsAndAccountGroupNameRequest$Type extends MessageType<ListAccountsByOrganizationIdsAndAccountGroupNameRequest> {
    constructor() {
        super("base.organization.ListAccountsByOrganizationIdsAndAccountGroupNameRequest", [
            { no: 1, name: "organizationIdList", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "accountGroupNameList", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListAccountsByOrganizationIdsAndAccountGroupNameRequest>): ListAccountsByOrganizationIdsAndAccountGroupNameRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationIdList = [];
        message.accountGroupNameList = [];
        if (value !== undefined)
            reflectionMergePartial<ListAccountsByOrganizationIdsAndAccountGroupNameRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAccountsByOrganizationIdsAndAccountGroupNameRequest): ListAccountsByOrganizationIdsAndAccountGroupNameRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 organizationIdList */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.organizationIdList.push(reader.int64().toString());
                    else
                        message.organizationIdList.push(reader.int64().toString());
                    break;
                case /* repeated string accountGroupNameList */ 2:
                    message.accountGroupNameList.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAccountsByOrganizationIdsAndAccountGroupNameRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 organizationIdList = 1; */
        if (message.organizationIdList.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.organizationIdList.length; i++)
                writer.int64(message.organizationIdList[i]);
            writer.join();
        }
        /* repeated string accountGroupNameList = 2; */
        for (let i = 0; i < message.accountGroupNameList.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.accountGroupNameList[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.ListAccountsByOrganizationIdsAndAccountGroupNameRequest
 */
export const ListAccountsByOrganizationIdsAndAccountGroupNameRequest = new ListAccountsByOrganizationIdsAndAccountGroupNameRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationByOrganizationGroupIdResponse$Type extends MessageType<GetOrganizationByOrganizationGroupIdResponse> {
    constructor() {
        super("base.organization.GetOrganizationByOrganizationGroupIdResponse", [
            { no: 1, name: "organization", kind: "message", T: () => Organization }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationByOrganizationGroupIdResponse>): GetOrganizationByOrganizationGroupIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationByOrganizationGroupIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationByOrganizationGroupIdResponse): GetOrganizationByOrganizationGroupIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.organization.Organization organization */ 1:
                    message.organization = Organization.internalBinaryRead(reader, reader.uint32(), options, message.organization);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationByOrganizationGroupIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.organization.Organization organization = 1; */
        if (message.organization)
            Organization.internalBinaryWrite(message.organization, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationByOrganizationGroupIdResponse
 */
export const GetOrganizationByOrganizationGroupIdResponse = new GetOrganizationByOrganizationGroupIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationByOrganizationGroupIdRequest$Type extends MessageType<GetOrganizationByOrganizationGroupIdRequest> {
    constructor() {
        super("base.organization.GetOrganizationByOrganizationGroupIdRequest", [
            { no: 1, name: "organizationGroupId", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationByOrganizationGroupIdRequest>): GetOrganizationByOrganizationGroupIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationByOrganizationGroupIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationByOrganizationGroupIdRequest): GetOrganizationByOrganizationGroupIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value organizationGroupId */ 1:
                    message.organizationGroupId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationGroupId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationByOrganizationGroupIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value organizationGroupId = 1; */
        if (message.organizationGroupId)
            Int64Value.internalBinaryWrite(message.organizationGroupId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationByOrganizationGroupIdRequest
 */
export const GetOrganizationByOrganizationGroupIdRequest = new GetOrganizationByOrganizationGroupIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NewGetAccountGroupAccountsByOrganizationIdsRequest$Type extends MessageType<NewGetAccountGroupAccountsByOrganizationIdsRequest> {
    constructor() {
        super("base.organization.NewGetAccountGroupAccountsByOrganizationIdsRequest", [
            { no: 1, name: "organizationIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<NewGetAccountGroupAccountsByOrganizationIdsRequest>): NewGetAccountGroupAccountsByOrganizationIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationIds = [];
        if (value !== undefined)
            reflectionMergePartial<NewGetAccountGroupAccountsByOrganizationIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NewGetAccountGroupAccountsByOrganizationIdsRequest): NewGetAccountGroupAccountsByOrganizationIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 organizationIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.organizationIds.push(reader.int64().toString());
                    else
                        message.organizationIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NewGetAccountGroupAccountsByOrganizationIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 organizationIds = 1; */
        if (message.organizationIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.organizationIds.length; i++)
                writer.int64(message.organizationIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.NewGetAccountGroupAccountsByOrganizationIdsRequest
 */
export const NewGetAccountGroupAccountsByOrganizationIdsRequest = new NewGetAccountGroupAccountsByOrganizationIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NewGetAccountGroupAccountsByOrganizationIdsResponse$Type extends MessageType<NewGetAccountGroupAccountsByOrganizationIdsResponse> {
    constructor() {
        super("base.organization.NewGetAccountGroupAccountsByOrganizationIdsResponse", [
            { no: 1, name: "accountGroupAccount", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccountGroupAccount }
        ]);
    }
    create(value?: PartialMessage<NewGetAccountGroupAccountsByOrganizationIdsResponse>): NewGetAccountGroupAccountsByOrganizationIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountGroupAccount = [];
        if (value !== undefined)
            reflectionMergePartial<NewGetAccountGroupAccountsByOrganizationIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NewGetAccountGroupAccountsByOrganizationIdsResponse): NewGetAccountGroupAccountsByOrganizationIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.organization.AccountGroupAccount accountGroupAccount */ 1:
                    message.accountGroupAccount.push(AccountGroupAccount.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NewGetAccountGroupAccountsByOrganizationIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.organization.AccountGroupAccount accountGroupAccount = 1; */
        for (let i = 0; i < message.accountGroupAccount.length; i++)
            AccountGroupAccount.internalBinaryWrite(message.accountGroupAccount[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.NewGetAccountGroupAccountsByOrganizationIdsResponse
 */
export const NewGetAccountGroupAccountsByOrganizationIdsResponse = new NewGetAccountGroupAccountsByOrganizationIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountGroupAccount$Type extends MessageType<AccountGroupAccount> {
    constructor() {
        super("base.organization.AccountGroupAccount", [
            { no: 1, name: "organization", kind: "message", T: () => Organization },
            { no: 2, name: "accountId", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "creationTimestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<AccountGroupAccount>): AccountGroupAccount {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = [];
        message.creationTimestamp = "0";
        if (value !== undefined)
            reflectionMergePartial<AccountGroupAccount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccountGroupAccount): AccountGroupAccount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.organization.Organization organization */ 1:
                    message.organization = Organization.internalBinaryRead(reader, reader.uint32(), options, message.organization);
                    break;
                case /* repeated int64 accountId */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountId.push(reader.int64().toString());
                    else
                        message.accountId.push(reader.int64().toString());
                    break;
                case /* int64 creationTimestamp */ 3:
                    message.creationTimestamp = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccountGroupAccount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.organization.Organization organization = 1; */
        if (message.organization)
            Organization.internalBinaryWrite(message.organization, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated int64 accountId = 2; */
        if (message.accountId.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountId.length; i++)
                writer.int64(message.accountId[i]);
            writer.join();
        }
        /* int64 creationTimestamp = 3; */
        if (message.creationTimestamp !== "0")
            writer.tag(3, WireType.Varint).int64(message.creationTimestamp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.AccountGroupAccount
 */
export const AccountGroupAccount = new AccountGroupAccount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddAccountToAccountGroupByAccountIdRequest$Type extends MessageType<AddAccountToAccountGroupByAccountIdRequest> {
    constructor() {
        super("base.organization.AddAccountToAccountGroupByAccountIdRequest", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "accountGroupId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<AddAccountToAccountGroupByAccountIdRequest>): AddAccountToAccountGroupByAccountIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        message.accountGroupId = "0";
        if (value !== undefined)
            reflectionMergePartial<AddAccountToAccountGroupByAccountIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddAccountToAccountGroupByAccountIdRequest): AddAccountToAccountGroupByAccountIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* int64 accountGroupId */ 2:
                    message.accountGroupId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddAccountToAccountGroupByAccountIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* int64 accountGroupId = 2; */
        if (message.accountGroupId !== "0")
            writer.tag(2, WireType.Varint).int64(message.accountGroupId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.AddAccountToAccountGroupByAccountIdRequest
 */
export const AddAccountToAccountGroupByAccountIdRequest = new AddAccountToAccountGroupByAccountIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddAccountToAccountGroupByAccountIdResponse$Type extends MessageType<AddAccountToAccountGroupByAccountIdResponse> {
    constructor() {
        super("base.organization.AddAccountToAccountGroupByAccountIdResponse", [
            { no: 1, name: "done", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AddAccountToAccountGroupByAccountIdResponse>): AddAccountToAccountGroupByAccountIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.done = false;
        if (value !== undefined)
            reflectionMergePartial<AddAccountToAccountGroupByAccountIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddAccountToAccountGroupByAccountIdResponse): AddAccountToAccountGroupByAccountIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool done */ 1:
                    message.done = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddAccountToAccountGroupByAccountIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool done = 1; */
        if (message.done !== false)
            writer.tag(1, WireType.Varint).bool(message.done);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.AddAccountToAccountGroupByAccountIdResponse
 */
export const AddAccountToAccountGroupByAccountIdResponse = new AddAccountToAccountGroupByAccountIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountGroupAccountsByOrganizationIdsRequest$Type extends MessageType<GetAccountGroupAccountsByOrganizationIdsRequest> {
    constructor() {
        super("base.organization.GetAccountGroupAccountsByOrganizationIdsRequest", [
            { no: 1, name: "organizationIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetAccountGroupAccountsByOrganizationIdsRequest>): GetAccountGroupAccountsByOrganizationIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetAccountGroupAccountsByOrganizationIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountGroupAccountsByOrganizationIdsRequest): GetAccountGroupAccountsByOrganizationIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 organizationIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.organizationIds.push(reader.int64().toString());
                    else
                        message.organizationIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountGroupAccountsByOrganizationIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 organizationIds = 1; */
        if (message.organizationIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.organizationIds.length; i++)
                writer.int64(message.organizationIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetAccountGroupAccountsByOrganizationIdsRequest
 */
export const GetAccountGroupAccountsByOrganizationIdsRequest = new GetAccountGroupAccountsByOrganizationIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountGroupAccountsByOrganizationIdsResponse$Type extends MessageType<GetAccountGroupAccountsByOrganizationIdsResponse> {
    constructor() {
        super("base.organization.GetAccountGroupAccountsByOrganizationIdsResponse", [
            { no: 1, name: "accountIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetAccountGroupAccountsByOrganizationIdsResponse>): GetAccountGroupAccountsByOrganizationIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetAccountGroupAccountsByOrganizationIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountGroupAccountsByOrganizationIdsResponse): GetAccountGroupAccountsByOrganizationIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 accountIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountIds.push(reader.int64().toString());
                    else
                        message.accountIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountGroupAccountsByOrganizationIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 accountIds = 1; */
        if (message.accountIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountIds.length; i++)
                writer.int64(message.accountIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetAccountGroupAccountsByOrganizationIdsResponse
 */
export const GetAccountGroupAccountsByOrganizationIdsResponse = new GetAccountGroupAccountsByOrganizationIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountByOrganizationIdRequest$Type extends MessageType<GetAccountByOrganizationIdRequest> {
    constructor() {
        super("base.organization.GetAccountByOrganizationIdRequest", [
            { no: 1, name: "organizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetAccountByOrganizationIdRequest>): GetAccountByOrganizationIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        if (value !== undefined)
            reflectionMergePartial<GetAccountByOrganizationIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountByOrganizationIdRequest): GetAccountByOrganizationIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationId */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountByOrganizationIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationId = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetAccountByOrganizationIdRequest
 */
export const GetAccountByOrganizationIdRequest = new GetAccountByOrganizationIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountByOrganizationIdResponse$Type extends MessageType<GetAccountByOrganizationIdResponse> {
    constructor() {
        super("base.organization.GetAccountByOrganizationIdResponse", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetAccountByOrganizationIdResponse>): GetAccountByOrganizationIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        if (value !== undefined)
            reflectionMergePartial<GetAccountByOrganizationIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountByOrganizationIdResponse): GetAccountByOrganizationIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountByOrganizationIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetAccountByOrganizationIdResponse
 */
export const GetAccountByOrganizationIdResponse = new GetAccountByOrganizationIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrganizationGroupRequest$Type extends MessageType<CreateOrganizationGroupRequest> {
    constructor() {
        super("base.organization.CreateOrganizationGroupRequest", [
            { no: 1, name: "createOrganizationGroup", kind: "message", T: () => CreateOrganizationGroup }
        ]);
    }
    create(value?: PartialMessage<CreateOrganizationGroupRequest>): CreateOrganizationGroupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateOrganizationGroupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrganizationGroupRequest): CreateOrganizationGroupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.organization.CreateOrganizationGroup createOrganizationGroup */ 1:
                    message.createOrganizationGroup = CreateOrganizationGroup.internalBinaryRead(reader, reader.uint32(), options, message.createOrganizationGroup);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrganizationGroupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.organization.CreateOrganizationGroup createOrganizationGroup = 1; */
        if (message.createOrganizationGroup)
            CreateOrganizationGroup.internalBinaryWrite(message.createOrganizationGroup, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.CreateOrganizationGroupRequest
 */
export const CreateOrganizationGroupRequest = new CreateOrganizationGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrganizationGroupResponse$Type extends MessageType<CreateOrganizationGroupResponse> {
    constructor() {
        super("base.organization.CreateOrganizationGroupResponse", [
            { no: 1, name: "organizationGroupId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreateOrganizationGroupResponse>): CreateOrganizationGroupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationGroupId = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateOrganizationGroupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrganizationGroupResponse): CreateOrganizationGroupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationGroupId */ 1:
                    message.organizationGroupId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrganizationGroupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationGroupId = 1; */
        if (message.organizationGroupId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationGroupId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.CreateOrganizationGroupResponse
 */
export const CreateOrganizationGroupResponse = new CreateOrganizationGroupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationByNameAndTypeRequest$Type extends MessageType<GetOrganizationByNameAndTypeRequest> {
    constructor() {
        super("base.organization.GetOrganizationByNameAndTypeRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationByNameAndTypeRequest>): GetOrganizationByNameAndTypeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.type = "";
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationByNameAndTypeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationByNameAndTypeRequest): GetOrganizationByNameAndTypeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string type */ 2:
                    message.type = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationByNameAndTypeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string type = 2; */
        if (message.type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationByNameAndTypeRequest
 */
export const GetOrganizationByNameAndTypeRequest = new GetOrganizationByNameAndTypeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationByNameAndTypeResponse$Type extends MessageType<GetOrganizationByNameAndTypeResponse> {
    constructor() {
        super("base.organization.GetOrganizationByNameAndTypeResponse", [
            { no: 1, name: "organization", kind: "message", T: () => Organization }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationByNameAndTypeResponse>): GetOrganizationByNameAndTypeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationByNameAndTypeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationByNameAndTypeResponse): GetOrganizationByNameAndTypeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.organization.Organization organization */ 1:
                    message.organization = Organization.internalBinaryRead(reader, reader.uint32(), options, message.organization);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationByNameAndTypeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.organization.Organization organization = 1; */
        if (message.organization)
            Organization.internalBinaryWrite(message.organization, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationByNameAndTypeResponse
 */
export const GetOrganizationByNameAndTypeResponse = new GetOrganizationByNameAndTypeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrganizationNameAndDescriptionRequest$Type extends MessageType<UpdateOrganizationNameAndDescriptionRequest> {
    constructor() {
        super("base.organization.UpdateOrganizationNameAndDescriptionRequest", [
            { no: 1, name: "organizationId", kind: "message", T: () => Int64Value },
            { no: 2, name: "name", kind: "message", T: () => StringValue },
            { no: 3, name: "description", kind: "message", T: () => StringValue },
            { no: 5, name: "organizationLogo", kind: "message", T: () => StringValue },
            { no: 6, name: "display_name", kind: "message", T: () => StringValue },
            { no: 7, name: "aliases", kind: "message", T: () => ListValue }
        ]);
    }
    create(value?: PartialMessage<UpdateOrganizationNameAndDescriptionRequest>): UpdateOrganizationNameAndDescriptionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateOrganizationNameAndDescriptionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateOrganizationNameAndDescriptionRequest): UpdateOrganizationNameAndDescriptionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value organizationId */ 1:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.StringValue name */ 2:
                    message.name = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.name);
                    break;
                case /* google.protobuf.StringValue description */ 3:
                    message.description = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.description);
                    break;
                case /* google.protobuf.StringValue organizationLogo */ 5:
                    message.organizationLogo = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.organizationLogo);
                    break;
                case /* google.protobuf.StringValue display_name */ 6:
                    message.displayName = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.displayName);
                    break;
                case /* google.protobuf.ListValue aliases */ 7:
                    message.aliases = ListValue.internalBinaryRead(reader, reader.uint32(), options, message.aliases);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateOrganizationNameAndDescriptionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value organizationId = 1; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue name = 2; */
        if (message.name)
            StringValue.internalBinaryWrite(message.name, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue description = 3; */
        if (message.description)
            StringValue.internalBinaryWrite(message.description, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue organizationLogo = 5; */
        if (message.organizationLogo)
            StringValue.internalBinaryWrite(message.organizationLogo, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue display_name = 6; */
        if (message.displayName)
            StringValue.internalBinaryWrite(message.displayName, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.ListValue aliases = 7; */
        if (message.aliases)
            ListValue.internalBinaryWrite(message.aliases, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.UpdateOrganizationNameAndDescriptionRequest
 */
export const UpdateOrganizationNameAndDescriptionRequest = new UpdateOrganizationNameAndDescriptionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrganizationNameAndDescriptionResponse$Type extends MessageType<UpdateOrganizationNameAndDescriptionResponse> {
    constructor() {
        super("base.organization.UpdateOrganizationNameAndDescriptionResponse", [
            { no: 1, name: "isUpdated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateOrganizationNameAndDescriptionResponse>): UpdateOrganizationNameAndDescriptionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isUpdated = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateOrganizationNameAndDescriptionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateOrganizationNameAndDescriptionResponse): UpdateOrganizationNameAndDescriptionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isUpdated */ 1:
                    message.isUpdated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateOrganizationNameAndDescriptionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isUpdated = 1; */
        if (message.isUpdated !== false)
            writer.tag(1, WireType.Varint).bool(message.isUpdated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.UpdateOrganizationNameAndDescriptionResponse
 */
export const UpdateOrganizationNameAndDescriptionResponse = new UpdateOrganizationNameAndDescriptionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrganizationGroupNameAndDescriptionRequest$Type extends MessageType<UpdateOrganizationGroupNameAndDescriptionRequest> {
    constructor() {
        super("base.organization.UpdateOrganizationGroupNameAndDescriptionRequest", [
            { no: 1, name: "organizationGroupId", kind: "message", T: () => Int64Value },
            { no: 2, name: "name", kind: "message", T: () => StringValue },
            { no: 3, name: "description", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<UpdateOrganizationGroupNameAndDescriptionRequest>): UpdateOrganizationGroupNameAndDescriptionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateOrganizationGroupNameAndDescriptionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateOrganizationGroupNameAndDescriptionRequest): UpdateOrganizationGroupNameAndDescriptionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value organizationGroupId */ 1:
                    message.organizationGroupId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationGroupId);
                    break;
                case /* google.protobuf.StringValue name */ 2:
                    message.name = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.name);
                    break;
                case /* google.protobuf.StringValue description */ 3:
                    message.description = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.description);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateOrganizationGroupNameAndDescriptionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value organizationGroupId = 1; */
        if (message.organizationGroupId)
            Int64Value.internalBinaryWrite(message.organizationGroupId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue name = 2; */
        if (message.name)
            StringValue.internalBinaryWrite(message.name, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue description = 3; */
        if (message.description)
            StringValue.internalBinaryWrite(message.description, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.UpdateOrganizationGroupNameAndDescriptionRequest
 */
export const UpdateOrganizationGroupNameAndDescriptionRequest = new UpdateOrganizationGroupNameAndDescriptionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrganizationGroupNameAndDescriptionResponse$Type extends MessageType<UpdateOrganizationGroupNameAndDescriptionResponse> {
    constructor() {
        super("base.organization.UpdateOrganizationGroupNameAndDescriptionResponse", [
            { no: 1, name: "isUpdated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateOrganizationGroupNameAndDescriptionResponse>): UpdateOrganizationGroupNameAndDescriptionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isUpdated = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateOrganizationGroupNameAndDescriptionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateOrganizationGroupNameAndDescriptionResponse): UpdateOrganizationGroupNameAndDescriptionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isUpdated */ 1:
                    message.isUpdated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateOrganizationGroupNameAndDescriptionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isUpdated = 1; */
        if (message.isUpdated !== false)
            writer.tag(1, WireType.Varint).bool(message.isUpdated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.UpdateOrganizationGroupNameAndDescriptionResponse
 */
export const UpdateOrganizationGroupNameAndDescriptionResponse = new UpdateOrganizationGroupNameAndDescriptionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrganizationRelationshipRequest$Type extends MessageType<CreateOrganizationRelationshipRequest> {
    constructor() {
        super("base.organization.CreateOrganizationRelationshipRequest", [
            { no: 1, name: "organizationId", kind: "message", T: () => Int64Value },
            { no: 2, name: "invatationOrganizationId", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<CreateOrganizationRelationshipRequest>): CreateOrganizationRelationshipRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateOrganizationRelationshipRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrganizationRelationshipRequest): CreateOrganizationRelationshipRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value organizationId */ 1:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.Int64Value invatationOrganizationId */ 2:
                    message.invatationOrganizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.invatationOrganizationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrganizationRelationshipRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value organizationId = 1; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value invatationOrganizationId = 2; */
        if (message.invatationOrganizationId)
            Int64Value.internalBinaryWrite(message.invatationOrganizationId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.CreateOrganizationRelationshipRequest
 */
export const CreateOrganizationRelationshipRequest = new CreateOrganizationRelationshipRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrganizationRelationshipResponse$Type extends MessageType<CreateOrganizationRelationshipResponse> {
    constructor() {
        super("base.organization.CreateOrganizationRelationshipResponse", [
            { no: 1, name: "organizationRelationshipId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreateOrganizationRelationshipResponse>): CreateOrganizationRelationshipResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationRelationshipId = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateOrganizationRelationshipResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrganizationRelationshipResponse): CreateOrganizationRelationshipResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationRelationshipId */ 1:
                    message.organizationRelationshipId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrganizationRelationshipResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationRelationshipId = 1; */
        if (message.organizationRelationshipId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationRelationshipId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.CreateOrganizationRelationshipResponse
 */
export const CreateOrganizationRelationshipResponse = new CreateOrganizationRelationshipResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteOrganizationRelationshipRequest$Type extends MessageType<DeleteOrganizationRelationshipRequest> {
    constructor() {
        super("base.organization.DeleteOrganizationRelationshipRequest", [
            { no: 1, name: "organizationRelationshipId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteOrganizationRelationshipRequest>): DeleteOrganizationRelationshipRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationRelationshipId = "0";
        if (value !== undefined)
            reflectionMergePartial<DeleteOrganizationRelationshipRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteOrganizationRelationshipRequest): DeleteOrganizationRelationshipRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationRelationshipId */ 1:
                    message.organizationRelationshipId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteOrganizationRelationshipRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationRelationshipId = 1; */
        if (message.organizationRelationshipId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationRelationshipId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.DeleteOrganizationRelationshipRequest
 */
export const DeleteOrganizationRelationshipRequest = new DeleteOrganizationRelationshipRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteOrganizationRelationshipResponse$Type extends MessageType<DeleteOrganizationRelationshipResponse> {
    constructor() {
        super("base.organization.DeleteOrganizationRelationshipResponse", [
            { no: 1, name: "isDeleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteOrganizationRelationshipResponse>): DeleteOrganizationRelationshipResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isDeleted = false;
        if (value !== undefined)
            reflectionMergePartial<DeleteOrganizationRelationshipResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteOrganizationRelationshipResponse): DeleteOrganizationRelationshipResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isDeleted */ 1:
                    message.isDeleted = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteOrganizationRelationshipResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isDeleted = 1; */
        if (message.isDeleted !== false)
            writer.tag(1, WireType.Varint).bool(message.isDeleted);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.DeleteOrganizationRelationshipResponse
 */
export const DeleteOrganizationRelationshipResponse = new DeleteOrganizationRelationshipResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AlterDefaultOrganizationRelationshipRequest$Type extends MessageType<AlterDefaultOrganizationRelationshipRequest> {
    constructor() {
        super("base.organization.AlterDefaultOrganizationRelationshipRequest", [
            { no: 1, name: "organizationRelationshipId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "invatationOrganizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<AlterDefaultOrganizationRelationshipRequest>): AlterDefaultOrganizationRelationshipRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationRelationshipId = "0";
        message.invatationOrganizationId = "0";
        if (value !== undefined)
            reflectionMergePartial<AlterDefaultOrganizationRelationshipRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AlterDefaultOrganizationRelationshipRequest): AlterDefaultOrganizationRelationshipRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationRelationshipId */ 1:
                    message.organizationRelationshipId = reader.int64().toString();
                    break;
                case /* int64 invatationOrganizationId */ 2:
                    message.invatationOrganizationId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AlterDefaultOrganizationRelationshipRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationRelationshipId = 1; */
        if (message.organizationRelationshipId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationRelationshipId);
        /* int64 invatationOrganizationId = 2; */
        if (message.invatationOrganizationId !== "0")
            writer.tag(2, WireType.Varint).int64(message.invatationOrganizationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.AlterDefaultOrganizationRelationshipRequest
 */
export const AlterDefaultOrganizationRelationshipRequest = new AlterDefaultOrganizationRelationshipRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AlterDefaultOrganizationRelationshipResponse$Type extends MessageType<AlterDefaultOrganizationRelationshipResponse> {
    constructor() {
        super("base.organization.AlterDefaultOrganizationRelationshipResponse", [
            { no: 1, name: "isAlter", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AlterDefaultOrganizationRelationshipResponse>): AlterDefaultOrganizationRelationshipResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isAlter = false;
        if (value !== undefined)
            reflectionMergePartial<AlterDefaultOrganizationRelationshipResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AlterDefaultOrganizationRelationshipResponse): AlterDefaultOrganizationRelationshipResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isAlter */ 1:
                    message.isAlter = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AlterDefaultOrganizationRelationshipResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isAlter = 1; */
        if (message.isAlter !== false)
            writer.tag(1, WireType.Varint).bool(message.isAlter);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.AlterDefaultOrganizationRelationshipResponse
 */
export const AlterDefaultOrganizationRelationshipResponse = new AlterDefaultOrganizationRelationshipResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationRelationshipResult$Type extends MessageType<OrganizationRelationshipResult> {
    constructor() {
        super("base.organization.OrganizationRelationshipResult", [
            { no: 1, name: "organizationId", kind: "message", T: () => Int64Value },
            { no: 2, name: "invatationOrganizationId", kind: "message", T: () => Int64Value },
            { no: 3, name: "isDefault", kind: "message", T: () => BoolValue },
            { no: 4, name: "id", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<OrganizationRelationshipResult>): OrganizationRelationshipResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<OrganizationRelationshipResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrganizationRelationshipResult): OrganizationRelationshipResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value organizationId */ 1:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.Int64Value invatationOrganizationId */ 2:
                    message.invatationOrganizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.invatationOrganizationId);
                    break;
                case /* google.protobuf.BoolValue isDefault */ 3:
                    message.isDefault = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.isDefault);
                    break;
                case /* google.protobuf.Int64Value id */ 4:
                    message.id = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrganizationRelationshipResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value organizationId = 1; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value invatationOrganizationId = 2; */
        if (message.invatationOrganizationId)
            Int64Value.internalBinaryWrite(message.invatationOrganizationId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.BoolValue isDefault = 3; */
        if (message.isDefault)
            BoolValue.internalBinaryWrite(message.isDefault, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value id = 4; */
        if (message.id)
            Int64Value.internalBinaryWrite(message.id, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.OrganizationRelationshipResult
 */
export const OrganizationRelationshipResult = new OrganizationRelationshipResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationRelationshipByIdRequest$Type extends MessageType<GetOrganizationRelationshipByIdRequest> {
    constructor() {
        super("base.organization.GetOrganizationRelationshipByIdRequest", [
            { no: 1, name: "organizationRelationshipId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationRelationshipByIdRequest>): GetOrganizationRelationshipByIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationRelationshipId = "0";
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationRelationshipByIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationRelationshipByIdRequest): GetOrganizationRelationshipByIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationRelationshipId */ 1:
                    message.organizationRelationshipId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationRelationshipByIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationRelationshipId = 1; */
        if (message.organizationRelationshipId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationRelationshipId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationRelationshipByIdRequest
 */
export const GetOrganizationRelationshipByIdRequest = new GetOrganizationRelationshipByIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationRelationshipByIdResponse$Type extends MessageType<GetOrganizationRelationshipByIdResponse> {
    constructor() {
        super("base.organization.GetOrganizationRelationshipByIdResponse", [
            { no: 1, name: "organizationRelationshipResult", kind: "message", T: () => OrganizationRelationshipResult }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationRelationshipByIdResponse>): GetOrganizationRelationshipByIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationRelationshipByIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationRelationshipByIdResponse): GetOrganizationRelationshipByIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.organization.OrganizationRelationshipResult organizationRelationshipResult */ 1:
                    message.organizationRelationshipResult = OrganizationRelationshipResult.internalBinaryRead(reader, reader.uint32(), options, message.organizationRelationshipResult);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationRelationshipByIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.organization.OrganizationRelationshipResult organizationRelationshipResult = 1; */
        if (message.organizationRelationshipResult)
            OrganizationRelationshipResult.internalBinaryWrite(message.organizationRelationshipResult, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationRelationshipByIdResponse
 */
export const GetOrganizationRelationshipByIdResponse = new GetOrganizationRelationshipByIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationRelationshipListByOrganizationIdRequest$Type extends MessageType<GetOrganizationRelationshipListByOrganizationIdRequest> {
    constructor() {
        super("base.organization.GetOrganizationRelationshipListByOrganizationIdRequest", [
            { no: 1, name: "organizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationRelationshipListByOrganizationIdRequest>): GetOrganizationRelationshipListByOrganizationIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationRelationshipListByOrganizationIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationRelationshipListByOrganizationIdRequest): GetOrganizationRelationshipListByOrganizationIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationId */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationRelationshipListByOrganizationIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationId = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationRelationshipListByOrganizationIdRequest
 */
export const GetOrganizationRelationshipListByOrganizationIdRequest = new GetOrganizationRelationshipListByOrganizationIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationRelationshipListByOrganizationIdResponse$Type extends MessageType<GetOrganizationRelationshipListByOrganizationIdResponse> {
    constructor() {
        super("base.organization.GetOrganizationRelationshipListByOrganizationIdResponse", [
            { no: 1, name: "organizationRelationshipResults", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrganizationRelationshipResult }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationRelationshipListByOrganizationIdResponse>): GetOrganizationRelationshipListByOrganizationIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationRelationshipResults = [];
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationRelationshipListByOrganizationIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationRelationshipListByOrganizationIdResponse): GetOrganizationRelationshipListByOrganizationIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.organization.OrganizationRelationshipResult organizationRelationshipResults */ 1:
                    message.organizationRelationshipResults.push(OrganizationRelationshipResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationRelationshipListByOrganizationIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.organization.OrganizationRelationshipResult organizationRelationshipResults = 1; */
        for (let i = 0; i < message.organizationRelationshipResults.length; i++)
            OrganizationRelationshipResult.internalBinaryWrite(message.organizationRelationshipResults[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationRelationshipListByOrganizationIdResponse
 */
export const GetOrganizationRelationshipListByOrganizationIdResponse = new GetOrganizationRelationshipListByOrganizationIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDefaultOrganizationRelationshipRequest$Type extends MessageType<GetDefaultOrganizationRelationshipRequest> {
    constructor() {
        super("base.organization.GetDefaultOrganizationRelationshipRequest", [
            { no: 1, name: "organizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetDefaultOrganizationRelationshipRequest>): GetDefaultOrganizationRelationshipRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        if (value !== undefined)
            reflectionMergePartial<GetDefaultOrganizationRelationshipRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDefaultOrganizationRelationshipRequest): GetDefaultOrganizationRelationshipRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationId */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDefaultOrganizationRelationshipRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationId = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetDefaultOrganizationRelationshipRequest
 */
export const GetDefaultOrganizationRelationshipRequest = new GetDefaultOrganizationRelationshipRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDefaultOrganizationRelationshipResponse$Type extends MessageType<GetDefaultOrganizationRelationshipResponse> {
    constructor() {
        super("base.organization.GetDefaultOrganizationRelationshipResponse", [
            { no: 1, name: "organizationRelationshipResult", kind: "message", T: () => OrganizationRelationshipResult }
        ]);
    }
    create(value?: PartialMessage<GetDefaultOrganizationRelationshipResponse>): GetDefaultOrganizationRelationshipResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetDefaultOrganizationRelationshipResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDefaultOrganizationRelationshipResponse): GetDefaultOrganizationRelationshipResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.organization.OrganizationRelationshipResult organizationRelationshipResult */ 1:
                    message.organizationRelationshipResult = OrganizationRelationshipResult.internalBinaryRead(reader, reader.uint32(), options, message.organizationRelationshipResult);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDefaultOrganizationRelationshipResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.organization.OrganizationRelationshipResult organizationRelationshipResult = 1; */
        if (message.organizationRelationshipResult)
            OrganizationRelationshipResult.internalBinaryWrite(message.organizationRelationshipResult, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetDefaultOrganizationRelationshipResponse
 */
export const GetDefaultOrganizationRelationshipResponse = new GetDefaultOrganizationRelationshipResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountGroupPermissionUUIDsRequest$Type extends MessageType<GetAccountGroupPermissionUUIDsRequest> {
    constructor() {
        super("base.organization.GetAccountGroupPermissionUUIDsRequest", [
            { no: 1, name: "organizationAccountGroups", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrganizationAccountGroup }
        ]);
    }
    create(value?: PartialMessage<GetAccountGroupPermissionUUIDsRequest>): GetAccountGroupPermissionUUIDsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationAccountGroups = [];
        if (value !== undefined)
            reflectionMergePartial<GetAccountGroupPermissionUUIDsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountGroupPermissionUUIDsRequest): GetAccountGroupPermissionUUIDsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.organization.OrganizationAccountGroup organizationAccountGroups */ 1:
                    message.organizationAccountGroups.push(OrganizationAccountGroup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountGroupPermissionUUIDsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.organization.OrganizationAccountGroup organizationAccountGroups = 1; */
        for (let i = 0; i < message.organizationAccountGroups.length; i++)
            OrganizationAccountGroup.internalBinaryWrite(message.organizationAccountGroups[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetAccountGroupPermissionUUIDsRequest
 */
export const GetAccountGroupPermissionUUIDsRequest = new GetAccountGroupPermissionUUIDsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationAccountGroup$Type extends MessageType<OrganizationAccountGroup> {
    constructor() {
        super("base.organization.OrganizationAccountGroup", [
            { no: 1, name: "organizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "accountGroupId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<OrganizationAccountGroup>): OrganizationAccountGroup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        message.accountGroupId = "0";
        if (value !== undefined)
            reflectionMergePartial<OrganizationAccountGroup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrganizationAccountGroup): OrganizationAccountGroup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationId */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                case /* int64 accountGroupId */ 2:
                    message.accountGroupId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrganizationAccountGroup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationId = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        /* int64 accountGroupId = 2; */
        if (message.accountGroupId !== "0")
            writer.tag(2, WireType.Varint).int64(message.accountGroupId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.OrganizationAccountGroup
 */
export const OrganizationAccountGroup = new OrganizationAccountGroup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountGroupPermissionUUIDsResponse$Type extends MessageType<GetAccountGroupPermissionUUIDsResponse> {
    constructor() {
        super("base.organization.GetAccountGroupPermissionUUIDsResponse", [
            { no: 1, name: "permissionUUIDs", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetAccountGroupPermissionUUIDsResponse>): GetAccountGroupPermissionUUIDsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.permissionUUIDs = [];
        if (value !== undefined)
            reflectionMergePartial<GetAccountGroupPermissionUUIDsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountGroupPermissionUUIDsResponse): GetAccountGroupPermissionUUIDsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated bytes permissionUUIDs */ 1:
                    message.permissionUUIDs.push(reader.bytes());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountGroupPermissionUUIDsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated bytes permissionUUIDs = 1; */
        for (let i = 0; i < message.permissionUUIDs.length; i++)
            writer.tag(1, WireType.LengthDelimited).bytes(message.permissionUUIDs[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetAccountGroupPermissionUUIDsResponse
 */
export const GetAccountGroupPermissionUUIDsResponse = new GetAccountGroupPermissionUUIDsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountGroupByAccountIdRequest$Type extends MessageType<GetAccountGroupByAccountIdRequest> {
    constructor() {
        super("base.organization.GetAccountGroupByAccountIdRequest", [
            { no: 1, name: "accountId", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<GetAccountGroupByAccountIdRequest>): GetAccountGroupByAccountIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAccountGroupByAccountIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountGroupByAccountIdRequest): GetAccountGroupByAccountIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value accountId */ 1:
                    message.accountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountGroupByAccountIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value accountId = 1; */
        if (message.accountId)
            Int64Value.internalBinaryWrite(message.accountId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetAccountGroupByAccountIdRequest
 */
export const GetAccountGroupByAccountIdRequest = new GetAccountGroupByAccountIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountGroupByAccountIdResponse$Type extends MessageType<GetAccountGroupByAccountIdResponse> {
    constructor() {
        super("base.organization.GetAccountGroupByAccountIdResponse", [
            { no: 1, name: "accountGroup", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetAccountGroupByAccountIdResponse_OrganizationAccountGroup }
        ]);
    }
    create(value?: PartialMessage<GetAccountGroupByAccountIdResponse>): GetAccountGroupByAccountIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountGroup = [];
        if (value !== undefined)
            reflectionMergePartial<GetAccountGroupByAccountIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountGroupByAccountIdResponse): GetAccountGroupByAccountIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.organization.GetAccountGroupByAccountIdResponse.OrganizationAccountGroup accountGroup */ 1:
                    message.accountGroup.push(GetAccountGroupByAccountIdResponse_OrganizationAccountGroup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountGroupByAccountIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.organization.GetAccountGroupByAccountIdResponse.OrganizationAccountGroup accountGroup = 1; */
        for (let i = 0; i < message.accountGroup.length; i++)
            GetAccountGroupByAccountIdResponse_OrganizationAccountGroup.internalBinaryWrite(message.accountGroup[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetAccountGroupByAccountIdResponse
 */
export const GetAccountGroupByAccountIdResponse = new GetAccountGroupByAccountIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountGroupByAccountIdResponse_OrganizationAccountGroup$Type extends MessageType<GetAccountGroupByAccountIdResponse_OrganizationAccountGroup> {
    constructor() {
        super("base.organization.GetAccountGroupByAccountIdResponse.OrganizationAccountGroup", [
            { no: 1, name: "organizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "accountGroupIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetAccountGroupByAccountIdResponse_OrganizationAccountGroup>): GetAccountGroupByAccountIdResponse_OrganizationAccountGroup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        message.accountGroupIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetAccountGroupByAccountIdResponse_OrganizationAccountGroup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountGroupByAccountIdResponse_OrganizationAccountGroup): GetAccountGroupByAccountIdResponse_OrganizationAccountGroup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationId */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                case /* repeated int64 accountGroupIds */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountGroupIds.push(reader.int64().toString());
                    else
                        message.accountGroupIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountGroupByAccountIdResponse_OrganizationAccountGroup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationId = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        /* repeated int64 accountGroupIds = 2; */
        if (message.accountGroupIds.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountGroupIds.length; i++)
                writer.int64(message.accountGroupIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetAccountGroupByAccountIdResponse.OrganizationAccountGroup
 */
export const GetAccountGroupByAccountIdResponse_OrganizationAccountGroup = new GetAccountGroupByAccountIdResponse_OrganizationAccountGroup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAccountGroupPermissionResponse$Type extends MessageType<DeleteAccountGroupPermissionResponse> {
    constructor() {
        super("base.organization.DeleteAccountGroupPermissionResponse", [
            { no: 1, name: "success", kind: "message", T: () => BoolValue }
        ]);
    }
    create(value?: PartialMessage<DeleteAccountGroupPermissionResponse>): DeleteAccountGroupPermissionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteAccountGroupPermissionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAccountGroupPermissionResponse): DeleteAccountGroupPermissionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.BoolValue success */ 1:
                    message.success = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAccountGroupPermissionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.BoolValue success = 1; */
        if (message.success)
            BoolValue.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.DeleteAccountGroupPermissionResponse
 */
export const DeleteAccountGroupPermissionResponse = new DeleteAccountGroupPermissionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAccountGroupPermissionRequest$Type extends MessageType<DeleteAccountGroupPermissionRequest> {
    constructor() {
        super("base.organization.DeleteAccountGroupPermissionRequest", [
            { no: 1, name: "organizationId", kind: "message", T: () => Int64Value },
            { no: 2, name: "accountGroupId", kind: "message", T: () => Int64Value },
            { no: 3, name: "UUIDs", kind: "scalar", jsonName: "UUIDs", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteAccountGroupPermissionRequest>): DeleteAccountGroupPermissionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.uUIDs = [];
        if (value !== undefined)
            reflectionMergePartial<DeleteAccountGroupPermissionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAccountGroupPermissionRequest): DeleteAccountGroupPermissionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value organizationId */ 1:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.Int64Value accountGroupId */ 2:
                    message.accountGroupId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountGroupId);
                    break;
                case /* repeated string UUIDs */ 3:
                    message.uUIDs.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAccountGroupPermissionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value organizationId = 1; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value accountGroupId = 2; */
        if (message.accountGroupId)
            Int64Value.internalBinaryWrite(message.accountGroupId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated string UUIDs = 3; */
        for (let i = 0; i < message.uUIDs.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.uUIDs[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.DeleteAccountGroupPermissionRequest
 */
export const DeleteAccountGroupPermissionRequest = new DeleteAccountGroupPermissionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAccountGroupPermissionUUIDResponse$Type extends MessageType<ListAccountGroupPermissionUUIDResponse> {
    constructor() {
        super("base.organization.ListAccountGroupPermissionUUIDResponse", [
            { no: 1, name: "permissionUUIDs", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<ListAccountGroupPermissionUUIDResponse>): ListAccountGroupPermissionUUIDResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.permissionUUIDs = [];
        if (value !== undefined)
            reflectionMergePartial<ListAccountGroupPermissionUUIDResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAccountGroupPermissionUUIDResponse): ListAccountGroupPermissionUUIDResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated bytes permissionUUIDs */ 1:
                    message.permissionUUIDs.push(reader.bytes());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAccountGroupPermissionUUIDResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated bytes permissionUUIDs = 1; */
        for (let i = 0; i < message.permissionUUIDs.length; i++)
            writer.tag(1, WireType.LengthDelimited).bytes(message.permissionUUIDs[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.ListAccountGroupPermissionUUIDResponse
 */
export const ListAccountGroupPermissionUUIDResponse = new ListAccountGroupPermissionUUIDResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAccountGroupPermissionUUIDRequest$Type extends MessageType<ListAccountGroupPermissionUUIDRequest> {
    constructor() {
        super("base.organization.ListAccountGroupPermissionUUIDRequest", [
            { no: 1, name: "organizationId", kind: "message", T: () => Int64Value },
            { no: 2, name: "accountGroupId", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<ListAccountGroupPermissionUUIDRequest>): ListAccountGroupPermissionUUIDRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListAccountGroupPermissionUUIDRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAccountGroupPermissionUUIDRequest): ListAccountGroupPermissionUUIDRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value organizationId */ 1:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.Int64Value accountGroupId */ 2:
                    message.accountGroupId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountGroupId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAccountGroupPermissionUUIDRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value organizationId = 1; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value accountGroupId = 2; */
        if (message.accountGroupId)
            Int64Value.internalBinaryWrite(message.accountGroupId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.ListAccountGroupPermissionUUIDRequest
 */
export const ListAccountGroupPermissionUUIDRequest = new ListAccountGroupPermissionUUIDRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAccountGroupPermissionResponse$Type extends MessageType<ListAccountGroupPermissionResponse> {
    constructor() {
        super("base.organization.ListAccountGroupPermissionResponse", [
            { no: 1, name: "accountGroupPermission", kind: "message", T: () => AccountGroupPermission }
        ]);
    }
    create(value?: PartialMessage<ListAccountGroupPermissionResponse>): ListAccountGroupPermissionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListAccountGroupPermissionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAccountGroupPermissionResponse): ListAccountGroupPermissionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.organization.AccountGroupPermission accountGroupPermission */ 1:
                    message.accountGroupPermission = AccountGroupPermission.internalBinaryRead(reader, reader.uint32(), options, message.accountGroupPermission);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAccountGroupPermissionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.organization.AccountGroupPermission accountGroupPermission = 1; */
        if (message.accountGroupPermission)
            AccountGroupPermission.internalBinaryWrite(message.accountGroupPermission, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.ListAccountGroupPermissionResponse
 */
export const ListAccountGroupPermissionResponse = new ListAccountGroupPermissionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountGroupPermission$Type extends MessageType<AccountGroupPermission> {
    constructor() {
        super("base.organization.AccountGroupPermission", [
            { no: 1, name: "organizationId", kind: "message", T: () => Int64Value },
            { no: 2, name: "accountGroupId", kind: "message", T: () => Int64Value },
            { no: 3, name: "permission", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Permission }
        ]);
    }
    create(value?: PartialMessage<AccountGroupPermission>): AccountGroupPermission {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.permission = [];
        if (value !== undefined)
            reflectionMergePartial<AccountGroupPermission>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccountGroupPermission): AccountGroupPermission {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value organizationId */ 1:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.Int64Value accountGroupId */ 2:
                    message.accountGroupId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountGroupId);
                    break;
                case /* repeated base.organization.Permission permission */ 3:
                    message.permission.push(Permission.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccountGroupPermission, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value organizationId = 1; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value accountGroupId = 2; */
        if (message.accountGroupId)
            Int64Value.internalBinaryWrite(message.accountGroupId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated base.organization.Permission permission = 3; */
        for (let i = 0; i < message.permission.length; i++)
            Permission.internalBinaryWrite(message.permission[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.AccountGroupPermission
 */
export const AccountGroupPermission = new AccountGroupPermission$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAccountGroupPermissionRequest$Type extends MessageType<ListAccountGroupPermissionRequest> {
    constructor() {
        super("base.organization.ListAccountGroupPermissionRequest", [
            { no: 1, name: "organizationId", kind: "message", T: () => Int64Value },
            { no: 2, name: "accountGroupId", kind: "message", T: () => Int64Value }
        ]);
    }
    create(value?: PartialMessage<ListAccountGroupPermissionRequest>): ListAccountGroupPermissionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListAccountGroupPermissionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAccountGroupPermissionRequest): ListAccountGroupPermissionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value organizationId */ 1:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.Int64Value accountGroupId */ 2:
                    message.accountGroupId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountGroupId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAccountGroupPermissionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value organizationId = 1; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value accountGroupId = 2; */
        if (message.accountGroupId)
            Int64Value.internalBinaryWrite(message.accountGroupId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.ListAccountGroupPermissionRequest
 */
export const ListAccountGroupPermissionRequest = new ListAccountGroupPermissionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthorizeToAccountGroupResponse$Type extends MessageType<AuthorizeToAccountGroupResponse> {
    constructor() {
        super("base.organization.AuthorizeToAccountGroupResponse", [
            { no: 1, name: "success", kind: "message", T: () => BoolValue }
        ]);
    }
    create(value?: PartialMessage<AuthorizeToAccountGroupResponse>): AuthorizeToAccountGroupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AuthorizeToAccountGroupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AuthorizeToAccountGroupResponse): AuthorizeToAccountGroupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.BoolValue success */ 1:
                    message.success = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.success);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AuthorizeToAccountGroupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.BoolValue success = 1; */
        if (message.success)
            BoolValue.internalBinaryWrite(message.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.AuthorizeToAccountGroupResponse
 */
export const AuthorizeToAccountGroupResponse = new AuthorizeToAccountGroupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthorizeToAccountGroupRequest$Type extends MessageType<AuthorizeToAccountGroupRequest> {
    constructor() {
        super("base.organization.AuthorizeToAccountGroupRequest", [
            { no: 1, name: "organizationId", kind: "message", T: () => Int64Value },
            { no: 2, name: "accountGroupId", kind: "message", T: () => Int64Value },
            { no: 3, name: "permissionUUIDs", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AuthorizeToAccountGroupRequest>): AuthorizeToAccountGroupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.permissionUUIDs = [];
        if (value !== undefined)
            reflectionMergePartial<AuthorizeToAccountGroupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AuthorizeToAccountGroupRequest): AuthorizeToAccountGroupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value organizationId */ 1:
                    message.organizationId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationId);
                    break;
                case /* google.protobuf.Int64Value accountGroupId */ 2:
                    message.accountGroupId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountGroupId);
                    break;
                case /* repeated string permissionUUIDs */ 3:
                    message.permissionUUIDs.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AuthorizeToAccountGroupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value organizationId = 1; */
        if (message.organizationId)
            Int64Value.internalBinaryWrite(message.organizationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value accountGroupId = 2; */
        if (message.accountGroupId)
            Int64Value.internalBinaryWrite(message.accountGroupId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated string permissionUUIDs = 3; */
        for (let i = 0; i < message.permissionUUIDs.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.permissionUUIDs[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.AuthorizeToAccountGroupRequest
 */
export const AuthorizeToAccountGroupRequest = new AuthorizeToAccountGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationByIdsRequest$Type extends MessageType<GetOrganizationByIdsRequest> {
    constructor() {
        super("base.organization.GetOrganizationByIdsRequest", [
            { no: 1, name: "ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationByIdsRequest>): GetOrganizationByIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ids = [];
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationByIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationByIdsRequest): GetOrganizationByIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 ids */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.ids.push(reader.int64().toString());
                    else
                        message.ids.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationByIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 ids = 1; */
        if (message.ids.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.ids.length; i++)
                writer.int64(message.ids[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationByIdsRequest
 */
export const GetOrganizationByIdsRequest = new GetOrganizationByIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationByIdsResponse$Type extends MessageType<GetOrganizationByIdsResponse> {
    constructor() {
        super("base.organization.GetOrganizationByIdsResponse", [
            { no: 1, name: "organizations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Organization }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationByIdsResponse>): GetOrganizationByIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizations = [];
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationByIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationByIdsResponse): GetOrganizationByIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.organization.Organization organizations */ 1:
                    message.organizations.push(Organization.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationByIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.organization.Organization organizations = 1; */
        for (let i = 0; i < message.organizations.length; i++)
            Organization.internalBinaryWrite(message.organizations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationByIdsResponse
 */
export const GetOrganizationByIdsResponse = new GetOrganizationByIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationsByTypeRequest$Type extends MessageType<GetOrganizationsByTypeRequest> {
    constructor() {
        super("base.organization.GetOrganizationsByTypeRequest", [
            { no: 1, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationsByTypeRequest>): GetOrganizationsByTypeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = "";
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationsByTypeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationsByTypeRequest): GetOrganizationsByTypeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string type */ 1:
                    message.type = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationsByTypeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string type = 1; */
        if (message.type !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationsByTypeRequest
 */
export const GetOrganizationsByTypeRequest = new GetOrganizationsByTypeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationsByTypeResponse$Type extends MessageType<GetOrganizationsByTypeResponse> {
    constructor() {
        super("base.organization.GetOrganizationsByTypeResponse", [
            { no: 1, name: "organizations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Organization }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationsByTypeResponse>): GetOrganizationsByTypeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizations = [];
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationsByTypeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationsByTypeResponse): GetOrganizationsByTypeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.organization.Organization organizations */ 1:
                    message.organizations.push(Organization.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationsByTypeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.organization.Organization organizations = 1; */
        for (let i = 0; i < message.organizations.length; i++)
            Organization.internalBinaryWrite(message.organizations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationsByTypeResponse
 */
export const GetOrganizationsByTypeResponse = new GetOrganizationsByTypeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationOrganizationsRequest$Type extends MessageType<GetOrganizationOrganizationsRequest> {
    constructor() {
        super("base.organization.GetOrganizationOrganizationsRequest", [
            { no: 1, name: "organizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationOrganizationsRequest>): GetOrganizationOrganizationsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationOrganizationsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationOrganizationsRequest): GetOrganizationOrganizationsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationId */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationOrganizationsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationId = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationOrganizationsRequest
 */
export const GetOrganizationOrganizationsRequest = new GetOrganizationOrganizationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationOrganizationsResponse$Type extends MessageType<GetOrganizationOrganizationsResponse> {
    constructor() {
        super("base.organization.GetOrganizationOrganizationsResponse", [
            { no: 1, name: "organizationGroups", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetOrganizationOrganizationsResponse_OrganizationGroupInfo }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationOrganizationsResponse>): GetOrganizationOrganizationsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationGroups = [];
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationOrganizationsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationOrganizationsResponse): GetOrganizationOrganizationsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.organization.GetOrganizationOrganizationsResponse.OrganizationGroupInfo organizationGroups */ 1:
                    message.organizationGroups.push(GetOrganizationOrganizationsResponse_OrganizationGroupInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationOrganizationsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.organization.GetOrganizationOrganizationsResponse.OrganizationGroupInfo organizationGroups = 1; */
        for (let i = 0; i < message.organizationGroups.length; i++)
            GetOrganizationOrganizationsResponse_OrganizationGroupInfo.internalBinaryWrite(message.organizationGroups[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationOrganizationsResponse
 */
export const GetOrganizationOrganizationsResponse = new GetOrganizationOrganizationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationOrganizationsResponse_OrganizationGroupInfo$Type extends MessageType<GetOrganizationOrganizationsResponse_OrganizationGroupInfo> {
    constructor() {
        super("base.organization.GetOrganizationOrganizationsResponse.OrganizationGroupInfo", [
            { no: 1, name: "organizationGroupId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "organizations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetOrganizationOrganizationsResponse_OrganizationInfo }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationOrganizationsResponse_OrganizationGroupInfo>): GetOrganizationOrganizationsResponse_OrganizationGroupInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationGroupId = "0";
        message.name = "";
        message.description = "";
        message.organizations = [];
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationOrganizationsResponse_OrganizationGroupInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationOrganizationsResponse_OrganizationGroupInfo): GetOrganizationOrganizationsResponse_OrganizationGroupInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationGroupId */ 1:
                    message.organizationGroupId = reader.int64().toString();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* repeated base.organization.GetOrganizationOrganizationsResponse.OrganizationInfo organizations */ 4:
                    message.organizations.push(GetOrganizationOrganizationsResponse_OrganizationInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationOrganizationsResponse_OrganizationGroupInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationGroupId = 1; */
        if (message.organizationGroupId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationGroupId);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* repeated base.organization.GetOrganizationOrganizationsResponse.OrganizationInfo organizations = 4; */
        for (let i = 0; i < message.organizations.length; i++)
            GetOrganizationOrganizationsResponse_OrganizationInfo.internalBinaryWrite(message.organizations[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationOrganizationsResponse.OrganizationGroupInfo
 */
export const GetOrganizationOrganizationsResponse_OrganizationGroupInfo = new GetOrganizationOrganizationsResponse_OrganizationGroupInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationOrganizationsResponse_OrganizationInfo$Type extends MessageType<GetOrganizationOrganizationsResponse_OrganizationInfo> {
    constructor() {
        super("base.organization.GetOrganizationOrganizationsResponse.OrganizationInfo", [
            { no: 1, name: "organizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "organizationGroups", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetOrganizationOrganizationsResponse_OrganizationGroupInfo }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationOrganizationsResponse_OrganizationInfo>): GetOrganizationOrganizationsResponse_OrganizationInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        message.name = "";
        message.description = "";
        message.organizationGroups = [];
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationOrganizationsResponse_OrganizationInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationOrganizationsResponse_OrganizationInfo): GetOrganizationOrganizationsResponse_OrganizationInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationId */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* repeated base.organization.GetOrganizationOrganizationsResponse.OrganizationGroupInfo organizationGroups */ 4:
                    message.organizationGroups.push(GetOrganizationOrganizationsResponse_OrganizationGroupInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationOrganizationsResponse_OrganizationInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationId = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* repeated base.organization.GetOrganizationOrganizationsResponse.OrganizationGroupInfo organizationGroups = 4; */
        for (let i = 0; i < message.organizationGroups.length; i++)
            GetOrganizationOrganizationsResponse_OrganizationGroupInfo.internalBinaryWrite(message.organizationGroups[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationOrganizationsResponse.OrganizationInfo
 */
export const GetOrganizationOrganizationsResponse_OrganizationInfo = new GetOrganizationOrganizationsResponse_OrganizationInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationParentOrganizationGroupRequest$Type extends MessageType<GetOrganizationParentOrganizationGroupRequest> {
    constructor() {
        super("base.organization.GetOrganizationParentOrganizationGroupRequest", [
            { no: 1, name: "organizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationParentOrganizationGroupRequest>): GetOrganizationParentOrganizationGroupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationParentOrganizationGroupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationParentOrganizationGroupRequest): GetOrganizationParentOrganizationGroupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationId */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationParentOrganizationGroupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationId = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationParentOrganizationGroupRequest
 */
export const GetOrganizationParentOrganizationGroupRequest = new GetOrganizationParentOrganizationGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationParentOrganizationGroupResponse$Type extends MessageType<GetOrganizationParentOrganizationGroupResponse> {
    constructor() {
        super("base.organization.GetOrganizationParentOrganizationGroupResponse", [
            { no: 1, name: "organizationGroup", kind: "message", T: () => OrganizationGroup }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationParentOrganizationGroupResponse>): GetOrganizationParentOrganizationGroupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationParentOrganizationGroupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationParentOrganizationGroupResponse): GetOrganizationParentOrganizationGroupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.organization.OrganizationGroup organizationGroup */ 1:
                    message.organizationGroup = OrganizationGroup.internalBinaryRead(reader, reader.uint32(), options, message.organizationGroup);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationParentOrganizationGroupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.organization.OrganizationGroup organizationGroup = 1; */
        if (message.organizationGroup)
            OrganizationGroup.internalBinaryWrite(message.organizationGroup, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationParentOrganizationGroupResponse
 */
export const GetOrganizationParentOrganizationGroupResponse = new GetOrganizationParentOrganizationGroupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrganizationsOrganizationGroupRequest$Type extends MessageType<UpdateOrganizationsOrganizationGroupRequest> {
    constructor() {
        super("base.organization.UpdateOrganizationsOrganizationGroupRequest", [
            { no: 1, name: "organizationIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "organizationGroupId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateOrganizationsOrganizationGroupRequest>): UpdateOrganizationsOrganizationGroupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationIds = [];
        message.organizationGroupId = "0";
        if (value !== undefined)
            reflectionMergePartial<UpdateOrganizationsOrganizationGroupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateOrganizationsOrganizationGroupRequest): UpdateOrganizationsOrganizationGroupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 organizationIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.organizationIds.push(reader.int64().toString());
                    else
                        message.organizationIds.push(reader.int64().toString());
                    break;
                case /* int64 organizationGroupId */ 2:
                    message.organizationGroupId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateOrganizationsOrganizationGroupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 organizationIds = 1; */
        if (message.organizationIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.organizationIds.length; i++)
                writer.int64(message.organizationIds[i]);
            writer.join();
        }
        /* int64 organizationGroupId = 2; */
        if (message.organizationGroupId !== "0")
            writer.tag(2, WireType.Varint).int64(message.organizationGroupId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.UpdateOrganizationsOrganizationGroupRequest
 */
export const UpdateOrganizationsOrganizationGroupRequest = new UpdateOrganizationsOrganizationGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateOrganizationsOrganizationGroupResponse$Type extends MessageType<UpdateOrganizationsOrganizationGroupResponse> {
    constructor() {
        super("base.organization.UpdateOrganizationsOrganizationGroupResponse", [
            { no: 1, name: "done", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateOrganizationsOrganizationGroupResponse>): UpdateOrganizationsOrganizationGroupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.done = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateOrganizationsOrganizationGroupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateOrganizationsOrganizationGroupResponse): UpdateOrganizationsOrganizationGroupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool done */ 1:
                    message.done = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateOrganizationsOrganizationGroupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool done = 1; */
        if (message.done !== false)
            writer.tag(1, WireType.Varint).bool(message.done);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.UpdateOrganizationsOrganizationGroupResponse
 */
export const UpdateOrganizationsOrganizationGroupResponse = new UpdateOrganizationsOrganizationGroupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationsByOrganizationGroupIdsRequest$Type extends MessageType<GetOrganizationsByOrganizationGroupIdsRequest> {
    constructor() {
        super("base.organization.GetOrganizationsByOrganizationGroupIdsRequest", [
            { no: 1, name: "organizationGroupIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationsByOrganizationGroupIdsRequest>): GetOrganizationsByOrganizationGroupIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationGroupIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationsByOrganizationGroupIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationsByOrganizationGroupIdsRequest): GetOrganizationsByOrganizationGroupIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 organizationGroupIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.organizationGroupIds.push(reader.int64().toString());
                    else
                        message.organizationGroupIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationsByOrganizationGroupIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 organizationGroupIds = 1; */
        if (message.organizationGroupIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.organizationGroupIds.length; i++)
                writer.int64(message.organizationGroupIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationsByOrganizationGroupIdsRequest
 */
export const GetOrganizationsByOrganizationGroupIdsRequest = new GetOrganizationsByOrganizationGroupIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationsByOrganizationGroupIdsResponse$Type extends MessageType<GetOrganizationsByOrganizationGroupIdsResponse> {
    constructor() {
        super("base.organization.GetOrganizationsByOrganizationGroupIdsResponse", [
            { no: 1, name: "organizationGroupList", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrganizationGroupList }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationsByOrganizationGroupIdsResponse>): GetOrganizationsByOrganizationGroupIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationGroupList = [];
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationsByOrganizationGroupIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationsByOrganizationGroupIdsResponse): GetOrganizationsByOrganizationGroupIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.organization.OrganizationGroupList organizationGroupList */ 1:
                    message.organizationGroupList.push(OrganizationGroupList.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationsByOrganizationGroupIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.organization.OrganizationGroupList organizationGroupList = 1; */
        for (let i = 0; i < message.organizationGroupList.length; i++)
            OrganizationGroupList.internalBinaryWrite(message.organizationGroupList[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationsByOrganizationGroupIdsResponse
 */
export const GetOrganizationsByOrganizationGroupIdsResponse = new GetOrganizationsByOrganizationGroupIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationGroupList$Type extends MessageType<OrganizationGroupList> {
    constructor() {
        super("base.organization.OrganizationGroupList", [
            { no: 1, name: "organizationGroupId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "organizationList", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Organization }
        ]);
    }
    create(value?: PartialMessage<OrganizationGroupList>): OrganizationGroupList {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationGroupId = "0";
        message.organizationList = [];
        if (value !== undefined)
            reflectionMergePartial<OrganizationGroupList>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrganizationGroupList): OrganizationGroupList {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationGroupId */ 1:
                    message.organizationGroupId = reader.int64().toString();
                    break;
                case /* repeated base.organization.Organization organizationList */ 2:
                    message.organizationList.push(Organization.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrganizationGroupList, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationGroupId = 1; */
        if (message.organizationGroupId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationGroupId);
        /* repeated base.organization.Organization organizationList = 2; */
        for (let i = 0; i < message.organizationList.length; i++)
            Organization.internalBinaryWrite(message.organizationList[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.OrganizationGroupList
 */
export const OrganizationGroupList = new OrganizationGroupList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Organization$Type extends MessageType<Organization> {
    constructor() {
        super("base.organization.Organization", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "type", kind: "message", T: () => StringValue },
            { no: 5, name: "organizationLogo", kind: "message", T: () => StringValue },
            { no: 6, name: "creationTimestamp", kind: "message", T: () => Int64Value },
            { no: 7, name: "parentOrganizationGroupId", kind: "message", T: () => Int64Value },
            { no: 8, name: "aliases", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Organization>): Organization {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.description = "";
        message.id = "0";
        message.aliases = [];
        if (value !== undefined)
            reflectionMergePartial<Organization>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Organization): Organization {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* int64 id */ 3:
                    message.id = reader.int64().toString();
                    break;
                case /* google.protobuf.StringValue type */ 4:
                    message.type = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.type);
                    break;
                case /* google.protobuf.StringValue organizationLogo */ 5:
                    message.organizationLogo = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.organizationLogo);
                    break;
                case /* google.protobuf.Int64Value creationTimestamp */ 6:
                    message.creationTimestamp = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.creationTimestamp);
                    break;
                case /* google.protobuf.Int64Value parentOrganizationGroupId */ 7:
                    message.parentOrganizationGroupId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.parentOrganizationGroupId);
                    break;
                case /* repeated string aliases */ 8:
                    message.aliases.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Organization, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* int64 id = 3; */
        if (message.id !== "0")
            writer.tag(3, WireType.Varint).int64(message.id);
        /* google.protobuf.StringValue type = 4; */
        if (message.type)
            StringValue.internalBinaryWrite(message.type, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue organizationLogo = 5; */
        if (message.organizationLogo)
            StringValue.internalBinaryWrite(message.organizationLogo, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value creationTimestamp = 6; */
        if (message.creationTimestamp)
            Int64Value.internalBinaryWrite(message.creationTimestamp, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value parentOrganizationGroupId = 7; */
        if (message.parentOrganizationGroupId)
            Int64Value.internalBinaryWrite(message.parentOrganizationGroupId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated string aliases = 8; */
        for (let i = 0; i < message.aliases.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.aliases[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.Organization
 */
export const Organization = new Organization$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationGroupsByOrganizationIdRequest$Type extends MessageType<GetOrganizationGroupsByOrganizationIdRequest> {
    constructor() {
        super("base.organization.GetOrganizationGroupsByOrganizationIdRequest", [
            { no: 1, name: "organizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationGroupsByOrganizationIdRequest>): GetOrganizationGroupsByOrganizationIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationGroupsByOrganizationIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationGroupsByOrganizationIdRequest): GetOrganizationGroupsByOrganizationIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationId */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationGroupsByOrganizationIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationId = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationGroupsByOrganizationIdRequest
 */
export const GetOrganizationGroupsByOrganizationIdRequest = new GetOrganizationGroupsByOrganizationIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationGroupsByOrganizationIdResponse$Type extends MessageType<GetOrganizationGroupsByOrganizationIdResponse> {
    constructor() {
        super("base.organization.GetOrganizationGroupsByOrganizationIdResponse", [
            { no: 1, name: "organizationGroups", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrganizationGroup }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationGroupsByOrganizationIdResponse>): GetOrganizationGroupsByOrganizationIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationGroups = [];
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationGroupsByOrganizationIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationGroupsByOrganizationIdResponse): GetOrganizationGroupsByOrganizationIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.organization.OrganizationGroup organizationGroups */ 1:
                    message.organizationGroups.push(OrganizationGroup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationGroupsByOrganizationIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.organization.OrganizationGroup organizationGroups = 1; */
        for (let i = 0; i < message.organizationGroups.length; i++)
            OrganizationGroup.internalBinaryWrite(message.organizationGroups[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationGroupsByOrganizationIdResponse
 */
export const GetOrganizationGroupsByOrganizationIdResponse = new GetOrganizationGroupsByOrganizationIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrganizationGroup$Type extends MessageType<OrganizationGroup> {
    constructor() {
        super("base.organization.OrganizationGroup", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OrganizationGroup>): OrganizationGroup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "0";
        message.name = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<OrganizationGroup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrganizationGroup): OrganizationGroup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toString();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrganizationGroup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== "0")
            writer.tag(1, WireType.Varint).int64(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.OrganizationGroup
 */
export const OrganizationGroup = new OrganizationGroup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountGroupContextRequest$Type extends MessageType<GetAccountGroupContextRequest> {
    constructor() {
        super("base.organization.GetAccountGroupContextRequest", []);
    }
    create(value?: PartialMessage<GetAccountGroupContextRequest>): GetAccountGroupContextRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAccountGroupContextRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountGroupContextRequest): GetAccountGroupContextRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountGroupContextRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetAccountGroupContextRequest
 */
export const GetAccountGroupContextRequest = new GetAccountGroupContextRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountGroupContextResponse$Type extends MessageType<GetAccountGroupContextResponse> {
    constructor() {
        super("base.organization.GetAccountGroupContextResponse", [
            { no: 1, name: "accountGroups", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccountGroupContext }
        ]);
    }
    create(value?: PartialMessage<GetAccountGroupContextResponse>): GetAccountGroupContextResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountGroups = [];
        if (value !== undefined)
            reflectionMergePartial<GetAccountGroupContextResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountGroupContextResponse): GetAccountGroupContextResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.organization.AccountGroupContext accountGroups */ 1:
                    message.accountGroups.push(AccountGroupContext.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountGroupContextResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.organization.AccountGroupContext accountGroups = 1; */
        for (let i = 0; i < message.accountGroups.length; i++)
            AccountGroupContext.internalBinaryWrite(message.accountGroups[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetAccountGroupContextResponse
 */
export const GetAccountGroupContextResponse = new GetAccountGroupContextResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountGroupContext$Type extends MessageType<AccountGroupContext> {
    constructor() {
        super("base.organization.AccountGroupContext", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "organizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<AccountGroupContext>): AccountGroupContext {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "0";
        message.name = "";
        message.description = "";
        message.organizationId = "0";
        if (value !== undefined)
            reflectionMergePartial<AccountGroupContext>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccountGroupContext): AccountGroupContext {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toString();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* int64 organizationId */ 4:
                    message.organizationId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccountGroupContext, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== "0")
            writer.tag(1, WireType.Varint).int64(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* int64 organizationId = 4; */
        if (message.organizationId !== "0")
            writer.tag(4, WireType.Varint).int64(message.organizationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.AccountGroupContext
 */
export const AccountGroupContext = new AccountGroupContext$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationContextRequest$Type extends MessageType<GetOrganizationContextRequest> {
    constructor() {
        super("base.organization.GetOrganizationContextRequest", [
            { no: 1, name: "type", kind: "enum", T: () => ["base.organization.OrganizationType", OrganizationType] }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationContextRequest>): GetOrganizationContextRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationContextRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationContextRequest): GetOrganizationContextRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.organization.OrganizationType type */ 1:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationContextRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.organization.OrganizationType type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationContextRequest
 */
export const GetOrganizationContextRequest = new GetOrganizationContextRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOrganizationContextResponse$Type extends MessageType<GetOrganizationContextResponse> {
    constructor() {
        super("base.organization.GetOrganizationContextResponse", [
            { no: 1, name: "organizationContext", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrganizationContext }
        ]);
    }
    create(value?: PartialMessage<GetOrganizationContextResponse>): GetOrganizationContextResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationContext = [];
        if (value !== undefined)
            reflectionMergePartial<GetOrganizationContextResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetOrganizationContextResponse): GetOrganizationContextResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.OrganizationContext organizationContext */ 1:
                    message.organizationContext.push(OrganizationContext.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetOrganizationContextResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.OrganizationContext organizationContext = 1; */
        for (let i = 0; i < message.organizationContext.length; i++)
            OrganizationContext.internalBinaryWrite(message.organizationContext[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetOrganizationContextResponse
 */
export const GetOrganizationContextResponse = new GetOrganizationContextResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountPermissionRequest$Type extends MessageType<GetAccountPermissionRequest> {
    constructor() {
        super("base.organization.GetAccountPermissionRequest", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetAccountPermissionRequest>): GetAccountPermissionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        if (value !== undefined)
            reflectionMergePartial<GetAccountPermissionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountPermissionRequest): GetAccountPermissionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountPermissionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetAccountPermissionRequest
 */
export const GetAccountPermissionRequest = new GetAccountPermissionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountPermissionResponse$Type extends MessageType<GetAccountPermissionResponse> {
    constructor() {
        super("base.organization.GetAccountPermissionResponse", [
            { no: 1, name: "organizationContext", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrganizationContext }
        ]);
    }
    create(value?: PartialMessage<GetAccountPermissionResponse>): GetAccountPermissionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationContext = [];
        if (value !== undefined)
            reflectionMergePartial<GetAccountPermissionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountPermissionResponse): GetAccountPermissionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.OrganizationContext organizationContext */ 1:
                    message.organizationContext.push(OrganizationContext.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountPermissionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.OrganizationContext organizationContext = 1; */
        for (let i = 0; i < message.organizationContext.length; i++)
            OrganizationContext.internalBinaryWrite(message.organizationContext[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetAccountPermissionResponse
 */
export const GetAccountPermissionResponse = new GetAccountPermissionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcceptUserInvitationRequest$Type extends MessageType<AcceptUserInvitationRequest> {
    constructor() {
        super("base.organization.AcceptUserInvitationRequest", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AcceptUserInvitationRequest>): AcceptUserInvitationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.uuid = "";
        if (value !== undefined)
            reflectionMergePartial<AcceptUserInvitationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcceptUserInvitationRequest): AcceptUserInvitationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string uuid */ 1:
                    message.uuid = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcceptUserInvitationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string uuid = 1; */
        if (message.uuid !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.uuid);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.AcceptUserInvitationRequest
 */
export const AcceptUserInvitationRequest = new AcceptUserInvitationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AcceptUserInvitationResponse$Type extends MessageType<AcceptUserInvitationResponse> {
    constructor() {
        super("base.organization.AcceptUserInvitationResponse", [
            { no: 1, name: "isAccepted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AcceptUserInvitationResponse>): AcceptUserInvitationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isAccepted = false;
        if (value !== undefined)
            reflectionMergePartial<AcceptUserInvitationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AcceptUserInvitationResponse): AcceptUserInvitationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isAccepted */ 1:
                    message.isAccepted = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AcceptUserInvitationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isAccepted = 1; */
        if (message.isAccepted !== false)
            writer.tag(1, WireType.Varint).bool(message.isAccepted);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.AcceptUserInvitationResponse
 */
export const AcceptUserInvitationResponse = new AcceptUserInvitationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserGroupInvitationUuidRequest$Type extends MessageType<GetUserGroupInvitationUuidRequest> {
    constructor() {
        super("base.organization.GetUserGroupInvitationUuidRequest", [
            { no: 1, name: "organizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "accountGroupId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetUserGroupInvitationUuidRequest>): GetUserGroupInvitationUuidRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        message.accountGroupId = "0";
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<GetUserGroupInvitationUuidRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetUserGroupInvitationUuidRequest): GetUserGroupInvitationUuidRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationId */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                case /* int64 accountGroupId */ 2:
                    message.accountGroupId = reader.int64().toString();
                    break;
                case /* int32 count */ 3:
                    message.count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetUserGroupInvitationUuidRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationId = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        /* int64 accountGroupId = 2; */
        if (message.accountGroupId !== "0")
            writer.tag(2, WireType.Varint).int64(message.accountGroupId);
        /* int32 count = 3; */
        if (message.count !== 0)
            writer.tag(3, WireType.Varint).int32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetUserGroupInvitationUuidRequest
 */
export const GetUserGroupInvitationUuidRequest = new GetUserGroupInvitationUuidRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserGroupInvitationUuidResponse$Type extends MessageType<GetUserGroupInvitationUuidResponse> {
    constructor() {
        super("base.organization.GetUserGroupInvitationUuidResponse", [
            { no: 1, name: "uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetUserGroupInvitationUuidResponse>): GetUserGroupInvitationUuidResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.uuid = "";
        if (value !== undefined)
            reflectionMergePartial<GetUserGroupInvitationUuidResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetUserGroupInvitationUuidResponse): GetUserGroupInvitationUuidResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string uuid */ 1:
                    message.uuid = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetUserGroupInvitationUuidResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string uuid = 1; */
        if (message.uuid !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.uuid);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetUserGroupInvitationUuidResponse
 */
export const GetUserGroupInvitationUuidResponse = new GetUserGroupInvitationUuidResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountGroupRequest$Type extends MessageType<GetAccountGroupRequest> {
    constructor() {
        super("base.organization.GetAccountGroupRequest", [
            { no: 1, name: "organizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetAccountGroupRequest>): GetAccountGroupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        if (value !== undefined)
            reflectionMergePartial<GetAccountGroupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountGroupRequest): GetAccountGroupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationId */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountGroupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationId = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetAccountGroupRequest
 */
export const GetAccountGroupRequest = new GetAccountGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountGroupResponse$Type extends MessageType<GetAccountGroupResponse> {
    constructor() {
        super("base.organization.GetAccountGroupResponse", [
            { no: 1, name: "accountGroup", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccountGroup }
        ]);
    }
    create(value?: PartialMessage<GetAccountGroupResponse>): GetAccountGroupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountGroup = [];
        if (value !== undefined)
            reflectionMergePartial<GetAccountGroupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountGroupResponse): GetAccountGroupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.organization.AccountGroup accountGroup */ 1:
                    message.accountGroup.push(AccountGroup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountGroupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.organization.AccountGroup accountGroup = 1; */
        for (let i = 0; i < message.accountGroup.length; i++)
            AccountGroup.internalBinaryWrite(message.accountGroup[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetAccountGroupResponse
 */
export const GetAccountGroupResponse = new GetAccountGroupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountGroup$Type extends MessageType<AccountGroup> {
    constructor() {
        super("base.organization.AccountGroup", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "displayName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "account_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AccountGroup>): AccountGroup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "0";
        message.name = "";
        message.displayName = "";
        message.description = "";
        message.accountCount = 0;
        if (value !== undefined)
            reflectionMergePartial<AccountGroup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccountGroup): AccountGroup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toString();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string displayName */ 3:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* int32 account_count */ 5:
                    message.accountCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccountGroup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== "0")
            writer.tag(1, WireType.Varint).int64(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string displayName = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* int32 account_count = 5; */
        if (message.accountCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.accountCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.AccountGroup
 */
export const AccountGroup = new AccountGroup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountGroupAccountRequest$Type extends MessageType<GetAccountGroupAccountRequest> {
    constructor() {
        super("base.organization.GetAccountGroupAccountRequest", [
            { no: 1, name: "organizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetAccountGroupAccountRequest>): GetAccountGroupAccountRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<GetAccountGroupAccountRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountGroupAccountRequest): GetAccountGroupAccountRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationId */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountGroupAccountRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationId = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetAccountGroupAccountRequest
 */
export const GetAccountGroupAccountRequest = new GetAccountGroupAccountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountGroupAccountResponse$Type extends MessageType<GetAccountGroupAccountResponse> {
    constructor() {
        super("base.organization.GetAccountGroupAccountResponse", [
            { no: 1, name: "organizationAccountId", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetAccountGroupAccountResponse>): GetAccountGroupAccountResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationAccountId = [];
        if (value !== undefined)
            reflectionMergePartial<GetAccountGroupAccountResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountGroupAccountResponse): GetAccountGroupAccountResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 organizationAccountId */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.organizationAccountId.push(reader.int64().toString());
                    else
                        message.organizationAccountId.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountGroupAccountResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 organizationAccountId = 1; */
        if (message.organizationAccountId.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.organizationAccountId.length; i++)
                writer.int64(message.organizationAccountId[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetAccountGroupAccountResponse
 */
export const GetAccountGroupAccountResponse = new GetAccountGroupAccountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveAccountFromAccountGroupRequest$Type extends MessageType<RemoveAccountFromAccountGroupRequest> {
    constructor() {
        super("base.organization.RemoveAccountFromAccountGroupRequest", [
            { no: 1, name: "accountGroupId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<RemoveAccountFromAccountGroupRequest>): RemoveAccountFromAccountGroupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountGroupId = "0";
        message.accountId = "0";
        if (value !== undefined)
            reflectionMergePartial<RemoveAccountFromAccountGroupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveAccountFromAccountGroupRequest): RemoveAccountFromAccountGroupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountGroupId */ 1:
                    message.accountGroupId = reader.int64().toString();
                    break;
                case /* int64 accountId */ 2:
                    message.accountId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveAccountFromAccountGroupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountGroupId = 1; */
        if (message.accountGroupId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountGroupId);
        /* int64 accountId = 2; */
        if (message.accountId !== "0")
            writer.tag(2, WireType.Varint).int64(message.accountId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.RemoveAccountFromAccountGroupRequest
 */
export const RemoveAccountFromAccountGroupRequest = new RemoveAccountFromAccountGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveAccountFromAccountGroupResponse$Type extends MessageType<RemoveAccountFromAccountGroupResponse> {
    constructor() {
        super("base.organization.RemoveAccountFromAccountGroupResponse", [
            { no: 1, name: "isRemoved", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<RemoveAccountFromAccountGroupResponse>): RemoveAccountFromAccountGroupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isRemoved = false;
        if (value !== undefined)
            reflectionMergePartial<RemoveAccountFromAccountGroupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveAccountFromAccountGroupResponse): RemoveAccountFromAccountGroupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isRemoved */ 1:
                    message.isRemoved = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveAccountFromAccountGroupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isRemoved = 1; */
        if (message.isRemoved !== false)
            writer.tag(1, WireType.Varint).bool(message.isRemoved);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.RemoveAccountFromAccountGroupResponse
 */
export const RemoveAccountFromAccountGroupResponse = new RemoveAccountFromAccountGroupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddAccountToAccountGroupRequest$Type extends MessageType<AddAccountToAccountGroupRequest> {
    constructor() {
        super("base.organization.AddAccountToAccountGroupRequest", [
            { no: 1, name: "accountGroupId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<AddAccountToAccountGroupRequest>): AddAccountToAccountGroupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountGroupId = "0";
        if (value !== undefined)
            reflectionMergePartial<AddAccountToAccountGroupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddAccountToAccountGroupRequest): AddAccountToAccountGroupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountGroupId */ 1:
                    message.accountGroupId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddAccountToAccountGroupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountGroupId = 1; */
        if (message.accountGroupId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountGroupId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.AddAccountToAccountGroupRequest
 */
export const AddAccountToAccountGroupRequest = new AddAccountToAccountGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddAccountToAccountGroupResponse$Type extends MessageType<AddAccountToAccountGroupResponse> {
    constructor() {
        super("base.organization.AddAccountToAccountGroupResponse", [
            { no: 1, name: "isAdded", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AddAccountToAccountGroupResponse>): AddAccountToAccountGroupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isAdded = false;
        if (value !== undefined)
            reflectionMergePartial<AddAccountToAccountGroupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddAccountToAccountGroupResponse): AddAccountToAccountGroupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isAdded */ 1:
                    message.isAdded = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddAccountToAccountGroupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isAdded = 1; */
        if (message.isAdded !== false)
            writer.tag(1, WireType.Varint).bool(message.isAdded);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.AddAccountToAccountGroupResponse
 */
export const AddAccountToAccountGroupResponse = new AddAccountToAccountGroupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeletedAccountGroupRequest$Type extends MessageType<DeletedAccountGroupRequest> {
    constructor() {
        super("base.organization.DeletedAccountGroupRequest", []);
    }
    create(value?: PartialMessage<DeletedAccountGroupRequest>): DeletedAccountGroupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeletedAccountGroupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeletedAccountGroupRequest): DeletedAccountGroupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeletedAccountGroupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.DeletedAccountGroupRequest
 */
export const DeletedAccountGroupRequest = new DeletedAccountGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeletedAccountGroupResponse$Type extends MessageType<DeletedAccountGroupResponse> {
    constructor() {
        super("base.organization.DeletedAccountGroupResponse", []);
    }
    create(value?: PartialMessage<DeletedAccountGroupResponse>): DeletedAccountGroupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeletedAccountGroupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeletedAccountGroupResponse): DeletedAccountGroupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeletedAccountGroupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.DeletedAccountGroupResponse
 */
export const DeletedAccountGroupResponse = new DeletedAccountGroupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountGroupRequest$Type extends MessageType<CreateAccountGroupRequest> {
    constructor() {
        super("base.organization.CreateAccountGroupRequest", [
            { no: 1, name: "createAccountGroup", kind: "message", T: () => CreateAccountGroup }
        ]);
    }
    create(value?: PartialMessage<CreateAccountGroupRequest>): CreateAccountGroupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateAccountGroupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAccountGroupRequest): CreateAccountGroupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.organization.CreateAccountGroup createAccountGroup */ 1:
                    message.createAccountGroup = CreateAccountGroup.internalBinaryRead(reader, reader.uint32(), options, message.createAccountGroup);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAccountGroupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.organization.CreateAccountGroup createAccountGroup = 1; */
        if (message.createAccountGroup)
            CreateAccountGroup.internalBinaryWrite(message.createAccountGroup, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.CreateAccountGroupRequest
 */
export const CreateAccountGroupRequest = new CreateAccountGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountGroup$Type extends MessageType<CreateAccountGroup> {
    constructor() {
        super("base.organization.CreateAccountGroup", [
            { no: 1, name: "organizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "displayName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "account_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<CreateAccountGroup>): CreateAccountGroup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        message.name = "";
        message.displayName = "";
        message.description = "";
        message.accountCount = 0;
        if (value !== undefined)
            reflectionMergePartial<CreateAccountGroup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAccountGroup): CreateAccountGroup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationId */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string displayName */ 3:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* int32 account_count */ 5:
                    message.accountCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAccountGroup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationId = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string displayName = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* int32 account_count = 5; */
        if (message.accountCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.accountCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.CreateAccountGroup
 */
export const CreateAccountGroup = new CreateAccountGroup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountGroupResponse$Type extends MessageType<CreateAccountGroupResponse> {
    constructor() {
        super("base.organization.CreateAccountGroupResponse", [
            { no: 1, name: "accountGroupId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreateAccountGroupResponse>): CreateAccountGroupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountGroupId = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateAccountGroupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAccountGroupResponse): CreateAccountGroupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountGroupId */ 1:
                    message.accountGroupId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAccountGroupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountGroupId = 1; */
        if (message.accountGroupId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountGroupId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.CreateAccountGroupResponse
 */
export const CreateAccountGroupResponse = new CreateAccountGroupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAccountGroupRequest$Type extends MessageType<UpdateAccountGroupRequest> {
    constructor() {
        super("base.organization.UpdateAccountGroupRequest", [
            { no: 1, name: "account_group_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "account_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateAccountGroupRequest>): UpdateAccountGroupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountGroupId = "0";
        message.name = "";
        message.displayName = "";
        message.description = "";
        message.accountCount = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateAccountGroupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateAccountGroupRequest): UpdateAccountGroupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 account_group_id */ 1:
                    message.accountGroupId = reader.int64().toString();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* int32 account_count */ 5:
                    message.accountCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateAccountGroupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 account_group_id = 1; */
        if (message.accountGroupId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountGroupId);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* int32 account_count = 5; */
        if (message.accountCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.accountCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.UpdateAccountGroupRequest
 */
export const UpdateAccountGroupRequest = new UpdateAccountGroupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAccountGroupResponse$Type extends MessageType<UpdateAccountGroupResponse> {
    constructor() {
        super("base.organization.UpdateAccountGroupResponse", [
            { no: 1, name: "account_group_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "account_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "organization_id", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateAccountGroupResponse>): UpdateAccountGroupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountGroupId = "0";
        message.name = "";
        message.displayName = "";
        message.description = "";
        message.accountCount = 0;
        message.organizationId = "0";
        if (value !== undefined)
            reflectionMergePartial<UpdateAccountGroupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateAccountGroupResponse): UpdateAccountGroupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 account_group_id */ 1:
                    message.accountGroupId = reader.int64().toString();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* int32 account_count */ 5:
                    message.accountCount = reader.int32();
                    break;
                case /* int64 organization_id */ 6:
                    message.organizationId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateAccountGroupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 account_group_id = 1; */
        if (message.accountGroupId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountGroupId);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* int32 account_count = 5; */
        if (message.accountCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.accountCount);
        /* int64 organization_id = 6; */
        if (message.organizationId !== "0")
            writer.tag(6, WireType.Varint).int64(message.organizationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.UpdateAccountGroupResponse
 */
export const UpdateAccountGroupResponse = new UpdateAccountGroupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrganizationGroup$Type extends MessageType<CreateOrganizationGroup> {
    constructor() {
        super("base.organization.CreateOrganizationGroup", [
            { no: 1, name: "parentOrganizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateOrganizationGroup>): CreateOrganizationGroup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.parentOrganizationId = "0";
        message.name = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<CreateOrganizationGroup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrganizationGroup): CreateOrganizationGroup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 parentOrganizationId */ 1:
                    message.parentOrganizationId = reader.int64().toString();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrganizationGroup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 parentOrganizationId = 1; */
        if (message.parentOrganizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.parentOrganizationId);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.CreateOrganizationGroup
 */
export const CreateOrganizationGroup = new CreateOrganizationGroup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteOrganizationRequest$Type extends MessageType<DeleteOrganizationRequest> {
    constructor() {
        super("base.organization.DeleteOrganizationRequest", [
            { no: 1, name: "organizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteOrganizationRequest>): DeleteOrganizationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        if (value !== undefined)
            reflectionMergePartial<DeleteOrganizationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteOrganizationRequest): DeleteOrganizationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationId */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteOrganizationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationId = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.DeleteOrganizationRequest
 */
export const DeleteOrganizationRequest = new DeleteOrganizationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteOrganizationResponse$Type extends MessageType<DeleteOrganizationResponse> {
    constructor() {
        super("base.organization.DeleteOrganizationResponse", [
            { no: 1, name: "isDeleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<DeleteOrganizationResponse>): DeleteOrganizationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isDeleted = false;
        if (value !== undefined)
            reflectionMergePartial<DeleteOrganizationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteOrganizationResponse): DeleteOrganizationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isDeleted */ 1:
                    message.isDeleted = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteOrganizationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isDeleted = 1; */
        if (message.isDeleted !== false)
            writer.tag(1, WireType.Varint).bool(message.isDeleted);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.DeleteOrganizationResponse
 */
export const DeleteOrganizationResponse = new DeleteOrganizationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrganizationRequest$Type extends MessageType<CreateOrganizationRequest> {
    constructor() {
        super("base.organization.CreateOrganizationRequest", [
            { no: 1, name: "createOrganization", kind: "message", T: () => CreateOrganization }
        ]);
    }
    create(value?: PartialMessage<CreateOrganizationRequest>): CreateOrganizationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateOrganizationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrganizationRequest): CreateOrganizationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* base.organization.CreateOrganization createOrganization */ 1:
                    message.createOrganization = CreateOrganization.internalBinaryRead(reader, reader.uint32(), options, message.createOrganization);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrganizationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* base.organization.CreateOrganization createOrganization = 1; */
        if (message.createOrganization)
            CreateOrganization.internalBinaryWrite(message.createOrganization, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.CreateOrganizationRequest
 */
export const CreateOrganizationRequest = new CreateOrganizationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrganizationResponse$Type extends MessageType<CreateOrganizationResponse> {
    constructor() {
        super("base.organization.CreateOrganizationResponse", [
            { no: 1, name: "organizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreateOrganizationResponse>): CreateOrganizationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateOrganizationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrganizationResponse): CreateOrganizationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationId */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrganizationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationId = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.CreateOrganizationResponse
 */
export const CreateOrganizationResponse = new CreateOrganizationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateOrganization$Type extends MessageType<CreateOrganization> {
    constructor() {
        super("base.organization.CreateOrganization", [
            { no: 1, name: "organizationGroupId", kind: "message", T: () => Int64Value },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "type", kind: "message", T: () => StringValue },
            { no: 5, name: "organizationLogo", kind: "message", T: () => StringValue },
            { no: 6, name: "display_name", kind: "message", T: () => StringValue },
            { no: 7, name: "aliases", kind: "message", T: () => ListValue }
        ]);
    }
    create(value?: PartialMessage<CreateOrganization>): CreateOrganization {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<CreateOrganization>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateOrganization): CreateOrganization {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value organizationGroupId */ 1:
                    message.organizationGroupId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.organizationGroupId);
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.StringValue type */ 4:
                    message.type = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.type);
                    break;
                case /* google.protobuf.StringValue organizationLogo */ 5:
                    message.organizationLogo = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.organizationLogo);
                    break;
                case /* google.protobuf.StringValue display_name */ 6:
                    message.displayName = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.displayName);
                    break;
                case /* google.protobuf.ListValue aliases */ 7:
                    message.aliases = ListValue.internalBinaryRead(reader, reader.uint32(), options, message.aliases);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateOrganization, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value organizationGroupId = 1; */
        if (message.organizationGroupId)
            Int64Value.internalBinaryWrite(message.organizationGroupId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.StringValue type = 4; */
        if (message.type)
            StringValue.internalBinaryWrite(message.type, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue organizationLogo = 5; */
        if (message.organizationLogo)
            StringValue.internalBinaryWrite(message.organizationLogo, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue display_name = 6; */
        if (message.displayName)
            StringValue.internalBinaryWrite(message.displayName, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.ListValue aliases = 7; */
        if (message.aliases)
            ListValue.internalBinaryWrite(message.aliases, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.CreateOrganization
 */
export const CreateOrganization = new CreateOrganization$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckOrganizationRequest$Type extends MessageType<CheckOrganizationRequest> {
    constructor() {
        super("base.organization.CheckOrganizationRequest", [
            { no: 1, name: "organizationId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CheckOrganizationRequest>): CheckOrganizationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.organizationId = "0";
        if (value !== undefined)
            reflectionMergePartial<CheckOrganizationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckOrganizationRequest): CheckOrganizationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 organizationId */ 1:
                    message.organizationId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckOrganizationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 organizationId = 1; */
        if (message.organizationId !== "0")
            writer.tag(1, WireType.Varint).int64(message.organizationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.CheckOrganizationRequest
 */
export const CheckOrganizationRequest = new CheckOrganizationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckOrganizationResponse$Type extends MessageType<CheckOrganizationResponse> {
    constructor() {
        super("base.organization.CheckOrganizationResponse", [
            { no: 1, name: "status", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CheckOrganizationResponse>): CheckOrganizationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = false;
        if (value !== undefined)
            reflectionMergePartial<CheckOrganizationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckOrganizationResponse): CheckOrganizationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool status */ 1:
                    message.status = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckOrganizationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool status = 1; */
        if (message.status !== false)
            writer.tag(1, WireType.Varint).bool(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.CheckOrganizationResponse
 */
export const CheckOrganizationResponse = new CheckOrganizationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPresignedPutObjectUrlRequest$Type extends MessageType<GetPresignedPutObjectUrlRequest> {
    constructor() {
        super("base.organization.GetPresignedPutObjectUrlRequest", [
            { no: 1, name: "object_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetPresignedPutObjectUrlRequest>): GetPresignedPutObjectUrlRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.objectType = "";
        message.key = "";
        if (value !== undefined)
            reflectionMergePartial<GetPresignedPutObjectUrlRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPresignedPutObjectUrlRequest): GetPresignedPutObjectUrlRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string object_type */ 1:
                    message.objectType = reader.string();
                    break;
                case /* string key */ 2:
                    message.key = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPresignedPutObjectUrlRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string object_type = 1; */
        if (message.objectType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.objectType);
        /* string key = 2; */
        if (message.key !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.key);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetPresignedPutObjectUrlRequest
 */
export const GetPresignedPutObjectUrlRequest = new GetPresignedPutObjectUrlRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPresignedPutObjectUrlResponse$Type extends MessageType<GetPresignedPutObjectUrlResponse> {
    constructor() {
        super("base.organization.GetPresignedPutObjectUrlResponse", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetPresignedPutObjectUrlResponse>): GetPresignedPutObjectUrlResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.key = "";
        message.url = "";
        if (value !== undefined)
            reflectionMergePartial<GetPresignedPutObjectUrlResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetPresignedPutObjectUrlResponse): GetPresignedPutObjectUrlResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                case /* string url */ 2:
                    message.url = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetPresignedPutObjectUrlResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        /* string url = 2; */
        if (message.url !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.url);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.organization.GetPresignedPutObjectUrlResponse
 */
export const GetPresignedPutObjectUrlResponse = new GetPresignedPutObjectUrlResponse$Type();
/**
 * @generated ServiceType for protobuf service base.organization.OrganizationService
 */
export const OrganizationService = new ServiceType("base.organization.OrganizationService", [
    { name: "CreateOrganizationGroup", options: { "google.api.http": { post: "/base.organization.OrganizationService/CreateOrganizationGroup", body: "*" } }, I: CreateOrganizationGroupRequest, O: CreateOrganizationGroupResponse },
    { name: "CreateOrganization", options: { "google.api.http": { post: "/base.organization.OrganizationService/CreateOrganization", body: "*" } }, I: CreateOrganizationRequest, O: CreateOrganizationResponse },
    { name: "CheckOrganization", options: { "google.api.http": { post: "/base.organization.OrganizationService/CheckOrganization", body: "*" } }, I: CheckOrganizationRequest, O: CheckOrganizationResponse },
    { name: "GetOrganizationGroupsByOrganizationId", options: { "google.api.http": { post: "/base.organization.OrganizationService/GetOrganizationGroupsByOrganizationId", body: "*" } }, I: GetOrganizationGroupsByOrganizationIdRequest, O: GetOrganizationGroupsByOrganizationIdResponse },
    { name: "GetOrganizationsByOrganizationGroupIds", options: { "google.api.http": { post: "/base.organization.OrganizationService/GetOrganizationsByOrganizationGroupIds", body: "*" } }, I: GetOrganizationsByOrganizationGroupIdsRequest, O: GetOrganizationsByOrganizationGroupIdsResponse },
    { name: "PageListOrganizations", options: { "google.api.http": { post: "/base.organization.OrganizationService/PageListOrganizations", body: "*" } }, I: PageListOrganizationsRequest, O: PageListOrganizationsResponse },
    { name: "UpdateOrganizationsOrganizationGroup", options: { "google.api.http": { post: "/base.organization.OrganizationService/UpdateOrganizationsOrganizationGroup", body: "*" } }, I: UpdateOrganizationsOrganizationGroupRequest, O: UpdateOrganizationsOrganizationGroupResponse },
    { name: "GetOrganizationParentOrganizationGroup", options: { "google.api.http": { post: "/base.organization.OrganizationService/GetOrganizationParentOrganizationGroup", body: "*" } }, I: GetOrganizationParentOrganizationGroupRequest, O: GetOrganizationParentOrganizationGroupResponse },
    { name: "GetOrganizationOrganizations", options: { "google.api.http": { post: "/base.organization.OrganizationService/GetOrganizationOrganizations", body: "*" } }, I: GetOrganizationOrganizationsRequest, O: GetOrganizationOrganizationsResponse },
    { name: "GetOrganizationByOrganizationGroupId", options: { "google.api.http": { post: "/base.organization.OrganizationService/GetOrganizationByOrganizationGroupId", body: "*" } }, I: GetOrganizationByOrganizationGroupIdRequest, O: GetOrganizationByOrganizationGroupIdResponse },
    { name: "GetOrganizationByIds", options: { "google.api.http": { post: "/base.organization.OrganizationService/GetOrganizationByIds", body: "*" } }, I: GetOrganizationByIdsRequest, O: GetOrganizationByIdsResponse },
    { name: "GetOrganizationsByType", options: { "google.api.http": { post: "/base.organization.OrganizationService/GetOrganizationsByType", body: "*" } }, I: GetOrganizationsByTypeRequest, O: GetOrganizationsByTypeResponse },
    { name: "UpdateOrganizationNameAndDescription", options: { "google.api.http": { post: "/base.organization.OrganizationService/UpdateOrganizationNameAndDescription", body: "*" } }, I: UpdateOrganizationNameAndDescriptionRequest, O: UpdateOrganizationNameAndDescriptionResponse },
    { name: "UpdateOrganizationGroupNameAndDescription", options: { "google.api.http": { post: "/base.organization.OrganizationService/UpdateOrganizationGroupNameAndDescription", body: "*" } }, I: UpdateOrganizationGroupNameAndDescriptionRequest, O: UpdateOrganizationGroupNameAndDescriptionResponse },
    { name: "GetOrganizationByNameAndType", options: { "google.api.http": { post: "/base.organization.OrganizationService/GetOrganizationByNameAndType", body: "*" } }, I: GetOrganizationByNameAndTypeRequest, O: GetOrganizationByNameAndTypeResponse },
    { name: "GetAccountByOrganizationId", options: {}, I: GetAccountByOrganizationIdRequest, O: GetAccountByOrganizationIdResponse },
    { name: "GetAccountGroupAccountsByOrganizationIds", options: { "google.api.http": { post: "/base.organization.OrganizationService/GetAccountGroupAccountsByOrganizationIds", body: "*" } }, I: GetAccountGroupAccountsByOrganizationIdsRequest, O: GetAccountGroupAccountsByOrganizationIdsResponse },
    { name: "NewGetAccountGroupAccountsByOrganizationIds", options: { "google.api.http": { post: "/base.organization.OrganizationService/NewGetAccountGroupAccountsByOrganizationIds", body: "*" } }, I: NewGetAccountGroupAccountsByOrganizationIdsRequest, O: NewGetAccountGroupAccountsByOrganizationIdsResponse },
    { name: "PageListAccountGroupAccounts", options: { "google.api.http": { post: "/base.organization.OrganizationService/PageListAccountGroupAccounts", body: "*" } }, I: PageListAccountGroupAccountsRequest, O: PageListAccountGroupAccountsResponse },
    { name: "ListAccountsByOrganizationIdsAndAccountGroupName", options: { "google.api.http": { post: "/base.organization.OrganizationService/ListAccountsByOrganizationIdsAndAccountGroupName", body: "*" } }, I: ListAccountsByOrganizationIdsAndAccountGroupNameRequest, O: ListAccountsByOrganizationIdsAndAccountGroupNameResponse },
    { name: "DeleteOrganization", options: { "google.api.http": { post: "/base.organization.OrganizationService/DeleteOrganization", body: "*" } }, I: DeleteOrganizationRequest, O: DeleteOrganizationResponse },
    { name: "GetOrganizationContext", options: { "google.api.http": { post: "/base.organization.OrganizationService/GetOrganizationContext", body: "*" } }, I: GetOrganizationContextRequest, O: GetOrganizationContextResponse },
    { name: "ListOrganizationByAccountId", options: { "google.api.http": { post: "/base.organization.OrganizationService/ListOrganizationByAccountId", body: "*" } }, I: ListOrganizationByAccountIdRequest, O: ListOrganizationByAccountIdResponse },
    { name: "ListOrganizations", options: { "google.api.http": { post: "/base.organization.OrganizationService/ListOrganizations", body: "*" } }, I: ListOrganizationsRequest, O: ListOrganizationsResponse },
    { name: "CreateAccountGroup", options: { "google.api.http": { post: "/base.organization.OrganizationService/CreateAccountGroup", body: "*" } }, I: CreateAccountGroupRequest, O: CreateAccountGroupResponse },
    { name: "UpdateAccountGroup", options: { "google.api.http": { post: "/base.organization.OrganizationService/UpdateAccountGroup", body: "*" } }, I: UpdateAccountGroupRequest, O: UpdateAccountGroupResponse },
    { name: "GetAccountGroup", options: { "google.api.http": { post: "/base.organization.OrganizationService/GetAccountGroup", body: "*" } }, I: GetAccountGroupRequest, O: GetAccountGroupResponse },
    { name: "AddAccountToAccountGroupByAccountId", options: { "google.api.http": { post: "/base.organization.OrganizationService/AddAccountToAccountGroupByAccountId", body: "*" } }, I: AddAccountToAccountGroupByAccountIdRequest, O: AddAccountToAccountGroupByAccountIdResponse },
    { name: "AddAccountToAccountGroup", options: { "google.api.http": { post: "/base.organization.OrganizationService/AddAccountToAccountGroup", body: "*" } }, I: AddAccountToAccountGroupRequest, O: AddAccountToAccountGroupResponse },
    { name: "GetAccountGroupByAccountId", options: {}, I: GetAccountGroupByAccountIdRequest, O: GetAccountGroupByAccountIdResponse },
    { name: "DeletedAccountGroup", options: {}, I: DeletedAccountGroupRequest, O: DeletedAccountGroupResponse },
    { name: "GetAccountGroupAccount", options: { "google.api.http": { post: "/base.organization.OrganizationService/GetAccountGroupAccount", body: "*" } }, I: GetAccountGroupAccountRequest, O: GetAccountGroupAccountResponse },
    { name: "RemoveAccountFromAccountGroup", options: { "google.api.http": { post: "/base.organization.OrganizationService/RemoveAccountFromAccountGroup", body: "*" } }, I: RemoveAccountFromAccountGroupRequest, O: RemoveAccountFromAccountGroupResponse },
    { name: "GetAccountGroupContext", options: { "google.api.http": { post: "/base.organization.OrganizationService/GetAccountGroupContext", body: "*" } }, I: GetAccountGroupContextRequest, O: GetAccountGroupContextResponse },
    { name: "GetUserGroupInvitationUuid", options: { "google.api.http": { post: "/base.organization.OrganizationService/GetUserGroupInvitationUuid", body: "*" } }, I: GetUserGroupInvitationUuidRequest, O: GetUserGroupInvitationUuidResponse },
    { name: "AcceptUserInvitation", options: { "google.api.http": { post: "/base.organization.OrganizationService/AcceptUserInvitation", body: "*" } }, I: AcceptUserInvitationRequest, O: AcceptUserInvitationResponse },
    { name: "GetAccountPermission", options: {}, I: GetAccountPermissionRequest, O: GetAccountPermissionResponse },
    { name: "AuthorizeToAccountGroup", options: { "google.api.http": { post: "/base.organization.OrganizationService/AuthorizeToAccountGroup", body: "*" } }, I: AuthorizeToAccountGroupRequest, O: AuthorizeToAccountGroupResponse },
    { name: "ListAccountGroupPermission", options: { "google.api.http": { post: "/base.organization.OrganizationService/ListAccountGroupPermission", body: "*" } }, I: ListAccountGroupPermissionRequest, O: ListAccountGroupPermissionResponse },
    { name: "ListAccountGroupPermissionUUID", options: { "google.api.http": { post: "/base.organization.OrganizationService/ListAccountGroupPermissionUUID", body: "*" } }, I: ListAccountGroupPermissionUUIDRequest, O: ListAccountGroupPermissionUUIDResponse },
    { name: "DeleteAccountGroupPermission", options: { "google.api.http": { post: "/base.organization.OrganizationService/DeleteAccountGroupPermission", body: "*" } }, I: DeleteAccountGroupPermissionRequest, O: DeleteAccountGroupPermissionResponse },
    { name: "GetAccountGroupPermissionUUIDs", options: { "google.api.http": { post: "/base.organization.OrganizationService/GetAccountGroupPermissionUUIDs", body: "*" } }, I: GetAccountGroupPermissionUUIDsRequest, O: GetAccountGroupPermissionUUIDsResponse },
    { name: "CreateOrganizationRelationship", options: { "google.api.http": { post: "/base.organization.OrganizationService/CreateOrganizationRelationship", body: "*" } }, I: CreateOrganizationRelationshipRequest, O: CreateOrganizationRelationshipResponse },
    { name: "DeleteOrganizationRelationship", options: { "google.api.http": { post: "/base.organization.OrganizationService/DeleteOrganizationRelationship", body: "*" } }, I: DeleteOrganizationRelationshipRequest, O: DeleteOrganizationRelationshipResponse },
    { name: "AlterDefaultOrganizationRelationship", options: { "google.api.http": { post: "/base.organization.OrganizationService/AlterDefaultOrganizationRelationship", body: "*" } }, I: AlterDefaultOrganizationRelationshipRequest, O: AlterDefaultOrganizationRelationshipResponse },
    { name: "GetOrganizationRelationshipById", options: { "google.api.http": { post: "/base.organization.OrganizationService/GetOrganizationRelationshipById", body: "*" } }, I: GetOrganizationRelationshipByIdRequest, O: GetOrganizationRelationshipByIdResponse },
    { name: "GetOrganizationRelationshipListByOrganizationId", options: { "google.api.http": { post: "/base.organization.OrganizationService/GetOrganizationRelationshipListByOrganizationId", body: "*" } }, I: GetOrganizationRelationshipListByOrganizationIdRequest, O: GetOrganizationRelationshipListByOrganizationIdResponse },
    { name: "GetDefaultOrganizationRelationship", options: { "google.api.http": { post: "/base.organization.OrganizationService/GetDefaultOrganizationRelationship", body: "*" } }, I: GetDefaultOrganizationRelationshipRequest, O: GetDefaultOrganizationRelationshipResponse },
    { name: "GetPresignedPutObjectUrl", options: { "google.api.http": { post: "/base.organization.OrganizationService/GetPresignedPutObjectUrl", body: "*" } }, I: GetPresignedPutObjectUrlRequest, O: GetPresignedPutObjectUrlResponse }
]);
